import { CustomRoute } from "@router/types";
import authCodeMap from "@/dataBase/authCodeMap";
const routes: Array<CustomRoute> = [
  {
    path: "/newCommunity",
    name: authCodeMap.newCom,
    component: (): any => import("@/modules/newCommunity/router.vue"),
    redirect: "/newCommunity/communityList",
    meta: {
      title: "newCom",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: authCodeMap.newCom,
      isNew: true,
    },
    children: [
      {
        path: "firstPage",
        name: "firstPage",
        component: (): any => import("@/modules/newCommunity/pages/firstPage/index.vue"),
        meta: {
          title: "", //中转页，跳到第一个有权限的菜单
          hidden: true,
          needLogin: true,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_subscribeCommunity,
        name: authCodeMap.newCom_subscribeCommunity,
        component: (): any => import("@/modules/newCommunity/pages/subscribeCommunity/subscribeCommunity.vue"),
        meta: {
          title: "订购",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_subscribeCommunity,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_operationSchool,
        name: authCodeMap.newCom_operationSchool,
        component: (): any => import("@/modules/newCommunity/pages/operationSchool/index.vue"),
        meta: {
          title: "社区概况",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_operationSchool,
          isNew: true,
          keepAlive: true,
        },
      },
      {
        path: authCodeMap.newCom_noticeList,
        name: authCodeMap.newCom_noticeList,
        component: (): any => import("@/modules/newCommunity/pages/operationSchool/noticeList.vue"),
        meta: {
          title: "平台公告",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_noticeList,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_noticeDetail,
        name: authCodeMap.newCom_noticeDetail,
        component: (): any => import("@/modules/newCommunity/pages/operationSchool/noticeDetail.vue"),
        meta: {
          title: "公告详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_noticeDetail,
          isNew: true,
        },
      },
      /* 公益讲堂 < */
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_liveActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_liveActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/activitySettingPage.vue"),
        meta: {
          title: "公益讲堂_活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_detail,
        name: authCodeMap.newCom_newActivityManage_liveActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityLiveManage_rewardList,
        name: authCodeMap.newCom_newActivityLiveManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityLiveManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_edit,
        name: authCodeMap.newCom_newActivityManage_liveActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_liveActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_liveActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_applyManageList,
        },
      },
      /* > 公益讲堂 */

      /* 医学会议 < */
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_requireList_setting,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_requireList_setting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/demandMangePage.vue"),
        meta: {
          title: "活动管理_需求管理_需求创建管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_requireList_setting,
          isBudgetSystemWhiteList: true,
        },
      },
      /*
    {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/activitySettingPage.vue"),
        meta: {
          title: "公益讲堂_活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_detail,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_requireList,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_requireList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/
        requireList.vue"),
        meta: {
          title: "活动管理_需求管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_requireList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_requireList_setting,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_requireList_setting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/requireListComponents/setting.vue"),
        meta: {
          title: "活动管理_需求管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_requireList_setting,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_rewardList,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_edit,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_meetingActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_meetingActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/meetingActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_meetingActivity_applyManageList,
        },
      },
     */
      /* > 医学会议 */

      {
        path: authCodeMap.goodsPromotionManage,
        name: authCodeMap.goodsPromotionManage,
        component: (): any => import("@/modules/newCommunity/pages/goodsPromotionManage/goodsPromotionList.vue"),
        meta: {
          title: "供应服务-零售商-商品推广",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.goodsPromotionManage,
          isNew: true,
        },
      },
      {
        path: authCodeMap.MerchantManage_join,
        name: authCodeMap.MerchantManage_join,
        component: (): any => import("@/modules/newCommunity/pages/merchantManage/join.vue"),
        meta: {
          title: "供应服务-零售商-零售商入驻",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.MerchantManage_join,
          isNew: true,
        },
      },
      {
        path: authCodeMap.MerchantManage_Goods_applyList,
        name: authCodeMap.MerchantManage_Goods_applyList,
        component: (): any => import("@/modules/newCommunity/pages/merchantManage/applyList.vue"),
        meta: {
          title: "商品发布",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.MerchantManage_Goods_applyList,
          isNew: true,
        },
      },
      {
        path: "MerchantManage_Goods_add_success",
        name: "MerchantManage_Goods_add_success",
        component: (): any => import("@/modules/newCommunity/pages/merchantManage/addSuccess.vue"),
        meta: {
          title: "商品发布成功",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.MerchantManage_Goods_applyList,
          isNew: true,
        },
      },
      {
        path: authCodeMap.MerchantManage_Goods_goodList,
        name: authCodeMap.MerchantManage_Goods_goodList,
        component: (): any => import("@/modules/newCommunity/pages/merchantManage/goodList.vue"),
        meta: {
          title: "供应商品库",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.MerchantManage_Goods_goodList,
          isNew: true,
        },
      },
      {
        path: authCodeMap.MerchantManage_Goods_add,
        name: authCodeMap.MerchantManage_Goods_add,
        component: (): any => import("@/modules/newCommunity/pages/merchantManage/goodsDetail.vue"),
        meta: {
          title: "供应服务-零售商-商品发布-新商品申请入库",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.MerchantManage_Goods_add,
          isNew: true,
        },
      },
      {
        path: authCodeMap.MerchantManage_Goods_detail,
        name: authCodeMap.MerchantManage_Goods_detail,
        component: (): any => import("@/modules/newCommunity/pages/merchantManage/goodsDetail.vue"),
        meta: {
          title: "供应服务-零售商-商品供应-商品详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.MerchantManage_Goods_detail,
          isNew: true,
        },
      },
      // {
      //   path: authCodeMap.MerchantManage_Goods_edit,
      //   name: authCodeMap.MerchantManage_Goods_edit,
      //   component: (): any => import("@/modules/newCommunity/pages/merchantManage/goodsDetail.vue"),
      //   meta: {
      //     title: "供应服务-零售商-商品供应-商品编辑",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.MerchantManage_Goods_edit,
      //     isNew: true,
      //   },
      // },
      {
        path: authCodeMap.MerchantManage_Performance,
        name: authCodeMap.MerchantManage_Performance,
        component: (): any => import("@/modules/newCommunity/pages/merchantManage/goodsOrderList.vue"),
        meta: {
          title: "供应服务-零售商-商品履约",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.MerchantManage_Performance,
          isNew: true,
        },
      },
      {
        path: "featuredProjects/promotionManage",
        name: authCodeMap.newCom_featuredProjects_promotionManage,
        component: (): any => import("@/modules/newCommunity/pages/featuredProjects/promotionManage.vue"),
        meta: {
          title: "特色项目_传播管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_featuredProjects_promotionManage,
          isNew: true,
        },
      },
      {
        path: "featuredProjects/list",
        name: authCodeMap.newCom_featuredProjects_list,
        component: (): any => import("@/modules/newCommunity/pages/featuredProjects/list.vue"),
        meta: {
          title: "特色项目_项目列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_featuredProjects_list,
          isNew: true,
        },
      },
      {
        path: "featuredProjects/add",
        name: authCodeMap.newCom_featuredProjects_add,
        component: (): any => import("@/modules/newCommunity/pages/featuredProjects/add.vue"),
        meta: {
          title: "特色项目_新建项目",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_featuredProjects_add,
          isNew: true,
        },
      },
      {
        path: "defaultActivity/promotionManage",
        name: authCodeMap.newCom_defaultActivity_promotionManage,
        component: (): any => import("@/modules/newCommunity/pages/defaultActivity/promotionManage.vue"),
        meta: {
          title: "精彩活动_传播管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_defaultActivity_promotionManage,
          isNew: true,
        },
      },
      {
        path: "defaultActivity/list",
        name: authCodeMap.newCom_defaultActivity_list,
        component: (): any => import("@/modules/newCommunity/pages/defaultActivity/list.vue"),
        meta: {
          title: "精彩活动_活动列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_defaultActivity_list,
          isNew: true,
        },
      },
      {
        path: "defaultActivity/add",
        name: authCodeMap.newCom_defaultActivity_add,
        component: (): any => import("@/modules/newCommunity/pages/defaultActivity/add.vue"),
        meta: {
          title: "精彩活动_新建活动",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_defaultActivity_add,
          isNew: true,
        },
      },
      {
        path: "defaultActivity/record",
        name: authCodeMap.newCom_defaultActivity_record,
        component: (): any => import("@/modules/newCommunity/pages/defaultActivity/record.vue"),
        meta: {
          title: "精彩活动_活动明细记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_defaultActivity_record,
          isNew: true,
        },
      },
      {
        path: "communityMessage",
        name: authCodeMap.newCom_basicSetting_communityMessage,
        component: (): any => import("@/modules/newCommunity/pages/basicSetting/message/index.vue"),
        meta: {
          title: "活动明细",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_basicSetting_communityMessage,
          isNew: true,
        },
      },
      /* 学术活动迁移新社区 start 23/11/22 */
      {
        path: "activeCenterDetail",
        name: authCodeMap.newCom_active_center_detail,
        component: (): any => import("@/modules/newCommunity/pages/activeCenter/activeDetail/index.vue"),
        meta: {
          title: "活动明细",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_active_center_detail,
          isNew: true,
        },
      },
      {
        path: "activeManage",
        name: authCodeMap.newCom_active_center_manage,
        component: (): any => import("@/modules/newCommunity/pages/activeCenter/activeManage/index.vue"),
        meta: {
          title: "活动管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_active_center_manage,
          isNew: true,
        },
      },
      {
        path: "activeManageEdit",
        name: authCodeMap.newCom_active_center_manage_edit,
        component: (): any => import("@/modules/newCommunity/pages/activeCenter/activeManage/edit.vue"),
        meta: {
          title: "新建活动",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_active_center_manage_edit,
          isNew: true,
        },
      },
      {
        path: "questionnaireSet",
        name: authCodeMap.newCom_active_center_manage_edit,
        component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaireEdit/components/questionnaireSet/index.vue"),
        meta: {
          title: "问卷设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_active_center_manage_edit,
          isNew: true,
        },
      },
      {
        path: "activeManageDetail",
        name: authCodeMap.newCom_active_center_manage_detail,
        component: (): any => import("@/modules/newCommunity/pages/activeCenter/activeManage/detail.vue"),
        meta: {
          title: "活动详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_active_center_manage_detail,
          isNew: true,
        },
      },
      {
        path: "case_activity",
        name: authCodeMap.newCom_case_activity,
        component: (): any => import("@/modules/newCommunity/pages/caseCollection/caseActivity/index.vue"),
        meta: {
          title: "活动工具_病例活动",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_case_activity,
          isNew: true,
        },
      },
      {
        path: "case_activity_add",
        name: authCodeMap.newCom_case_activity_add,
        component: (): any => import("@/modules/newCommunity/pages/caseCollection/caseActivity/add.vue"),
        meta: {
          title: "活动工具_病例活动_新增",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_case_activity_add,
          isNew: true,
        },
      },
      {
        path: "case_activity_detail",
        name: authCodeMap.newCom_case_activity_Detail,
        component: (): any => import("@/modules/newCommunity/pages/caseCollection/caseActivity/detail.vue"),
        meta: {
          title: "活动工具_病例活动_详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_case_activity_Detail,
          isNew: true,
        },
      },
      {
        path: "case_manager",
        name: authCodeMap.newCom_case_manager,
        component: (): any => import("@/modules/newCommunity/pages/caseCollection/caseManager/index.vue"),
        meta: {
          title: "活动工具_病例管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_case_manager,
          isNew: true,
        },
      },
      // {
      //   path: "questionnaire",
      //   name: authCodeMap.newCom_operationTools_questionnaire,
      //   component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/index.vue"),
      //   meta: {
      //     title: "活动工具_问卷",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.newCom_operationTools_questionnaire,
      //     activeTool: "questionaireManage",
      //     isNew: true,
      //   },
      // },
      {
        path: "questionnaire/questionaireManage",
        name: authCodeMap.newCom_operationTools_questionnaire_questionaireManage,
        component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/index.vue"),
        meta: {
          title: "活动工具_问卷答题",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_operationTools_questionnaire_questionaireManage,
          activeTool: "questionaireManage",
          isNew: true,
        },
      },
      {
        path: "questionnaire/questionBank",
        name: authCodeMap.newCom_operationTools_questionnaire_questionBank,
        component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/index.vue"),
        meta: {
          title: "活动工具_题库管理",
          hidden: true,
          needLogin: true,
          activeTool: "questionBank",
          authCode: authCodeMap.newCom_operationTools_questionnaire_questionBank,
          isNew: true,
        },
      },
      {
        path: "addQuestion",
        name: authCodeMap.newCom_operationTools_addQuestion,
        component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/addQuestion.vue"),
        meta: {
          title: "新增题目",
          hidden: true,
          needLogin: true,
          // authCode: authCodeMap.newCom_operationTools_questionBank_addBtn,
          authCode: authCodeMap.newCom_operationTools_addQuestion,
          isNew: true,
        },
      },
      {
        path: "catalogManage",
        name: authCodeMap.newCom_operationTools_catalogManage,
        component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/QuestionCatalogManagePage.vue"),
        meta: {
          title: "分类管理",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_operationTools_catalogManage,
          isNew: true,
        },
      },
      {
        path: "questionnaire/answerSheetPage",
        name: authCodeMap.newCom_questionnaire_answerSheetPage,
        component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/answerSheetPage.vue"),
        meta: {
          title: "活动工具_问卷_答卷",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_questionnaire_answerSheetPage,
          isNew: true,
        },
      },
      // {
      //   path: "questionnaire/answerSheetPage/answerSheetDetail",
      //   name: authCodeMap.newCom_questionnaire_answerSheetDetail,
      //   component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/answerSheetDetail.vue"),
      //   meta: {
      //     title: "活动工具_问卷_答卷详情",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.newCom_questionnaire_answerSheetDetail,
      //     isNew: true,
      //   },
      // },
      {
        path: "questionnaireEdit",
        name: authCodeMap.newCom_questionnaire_edit,
        component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaireEdit/index.vue"),
        meta: {
          title: "活动工具_新建问卷",
          hidden: true,
          needLogin: true,
          keepAlive: false,
          authCode: authCodeMap.newCom_questionnaire_edit,
          isNew: true,
        },
      },
      /* 学术活动迁移新社区 end */
      {
        path: "contentManage/activityList",
        name: authCodeMap.newCom_contentManage_activityList,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/activityList.vue"),
        meta: {
          title: "内容管理-活动内容管理列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_contentManage_activityList,
          isNew: true,
        },
      },
      {
        path: "contentManage/list",
        name: authCodeMap.newCom_content_management_list,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_management_list,
          isNew: true,
        },
      },
      {
        path: "contentManage/list/NEWS",
        name: authCodeMap.newCom_content_management_list_NEWS,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表_新闻资讯列表",
          hidden: false,
          needLogin: true,
          articleType: "NEWS",
          authCode: authCodeMap.newCom_content_management_list_NEWS,
          isNew: true,
        },
      },
      {
        path: "contentManage/list/POPULAR_SCIENCE",
        name: authCodeMap.newCom_content_management_list_POPULAR_SCIENCE,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表_科普文章列表",
          hidden: false,
          needLogin: true,
          articleType: "POPULAR_SCIENCE",
          authCode: authCodeMap.newCom_content_management_list_POPULAR_SCIENCE,
          isNew: true,
        },
      },
      {
        path: "contentManage/list/VIDEO",
        name: authCodeMap.newCom_content_management_list_VIDEO,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表_科普视频列表",
          hidden: false,
          needLogin: true,
          articleType: "VIDEO",
          authCode: authCodeMap.newCom_content_management_list_VIDEO,
          isNew: true,
        },
      },
      {
        path: "contentManage/list/HEALTH_INTERVIEW",
        name: authCodeMap.newCom_content_management_list_HEALTH_INTERVIEW,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表_科普专访列表",
          hidden: false,
          needLogin: true,
          articleType: "HEALTH_INTERVIEW",
          authCode: authCodeMap.newCom_content_management_list_HEALTH_INTERVIEW,
          isNew: true,
        },
      },
      {
        path: "contentManage/list/ASK_ANSWER_QUICKLY",
        name: authCodeMap.newCom_content_management_list_ASK_ANSWER_QUICKLY,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表_快问快答列表",
          hidden: false,
          needLogin: true,
          articleType: "ASK_ANSWER_QUICKLY",
          authCode: authCodeMap.newCom_content_management_list_ASK_ANSWER_QUICKLY,
          isNew: true,
        },
      },
      {
        path: "contentManage/list/PATHOLOGICAL_ANALYSIS",
        name: authCodeMap.newCom_content_management_list_PATHOLOGICAL_ANALYSIS,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表_病例分析列表",
          hidden: false,
          needLogin: true,
          articleType: "PATHOLOGICAL_ANALYSIS",
          authCode: authCodeMap.newCom_content_management_list_PATHOLOGICAL_ANALYSIS,
          isNew: true,
        },
      },
      {
        path: "contentManage/list/LIVE_PUBLIC_WELFARE",
        name: authCodeMap.newCom_content_management_list_LIVE_PUBLIC_WELFARE,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表_病例分析列表",
          hidden: false,
          needLogin: true,
          articleType: "LIVE_PUBLIC_WELFARE",
          authCode: authCodeMap.newCom_content_management_list_LIVE_PUBLIC_WELFARE,
          isNew: true,
        },
      },
      {
        path: "contentManage/list/DIARY",
        name: authCodeMap.newCom_content_management_list_DIARY,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/list.vue"),
        meta: {
          title: "内容管理-内容管理列表_诊间日记列表",
          hidden: false,
          needLogin: true,
          articleType: "DIARY",
          authCode: authCodeMap.newCom_content_management_list_DIARY,
          isNew: true,
        },
      },
      {
        path: "contentManage/setting",
        name: authCodeMap.newCom_content_management_setting,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/setting/index.vue"),
        meta: {
          title: "内容管理-内容列表设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_management_setting,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_content_management_communicationManage,
        name: authCodeMap.newCom_content_management_communicationManage,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/communicationManage/index.vue"),
        meta: {
          title: "健康服务-内容管理-传播管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_management_communicationManage,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_content_management_promotionManage,
        name: authCodeMap.newCom_content_management_promotionManage,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/promotionManage/index.vue"),
        meta: {
          title: "健康服务-内容管理-推广管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_management_promotionManage,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_doctorContent_management_communicationManage,
        name: authCodeMap.newCom_doctorContent_management_communicationManage,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/communicationManage/index.vue"),
        meta: {
          title: "医学服务-内容管理-传播管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorContent_management_communicationManage,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_content_management_distributeRecord,
        name: authCodeMap.newCom_content_management_distributeRecord,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/distributeRecord.vue"),
        meta: {
          title: "健康服务-内容管理-分发记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_management_distributeRecord,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_doctorContent_management_distributeRecord,
        name: authCodeMap.newCom_doctorContent_management_distributeRecord,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/distributeRecord.vue"),
        meta: {
          title: "医学服务-内容管理-分发记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorContent_management_distributeRecord,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_doctorContent_management_classify,
        name: authCodeMap.newCom_doctorContent_management_classify,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/classify/index.vue"),
        meta: {
          title: "医学服务-内容管理-分组",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorContent_management_classify,
          isNew: true,
        },
      },
      {
        path: "contentSynchronization/settings",
        name: authCodeMap.newCom_content_synchronization_settings,
        component: (): any => import("@/modules/newCommunity/pages/contentSynchronization/settings.vue"),
        meta: {
          title: "内容同步_内容同步设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_synchronization_settings,
          isNew: true,
        },
      },
      {
        path: "contentSynchronization/list/POPULAR_SCIENCE",
        name: authCodeMap.newCom_content_synchronization_list_POPULAR_SCIENCE,
        component: (): any => import("@/modules/newCommunity/pages/contentSynchronization/list.vue"),
        meta: {
          title: "内容同步_同步列表_科普文章列表",
          hidden: false,
          needLogin: true,
          articleType: "POPULAR_SCIENCE",
          authCode: authCodeMap.newCom_content_synchronization_list_POPULAR_SCIENCE,
          isNew: true,
          keepAlive: false,
        },
      },
      {
        path: "contentSynchronization/list/VIDEO",
        name: authCodeMap.newCom_content_synchronization_list_VIDEO,
        component: (): any => import("@/modules/newCommunity/pages/contentSynchronization/list.vue"),
        meta: {
          title: "内容同步_同步列表_科普视频列表",
          hidden: false,
          needLogin: true,
          articleType: "VIDEO",
          authCode: authCodeMap.newCom_content_synchronization_list_VIDEO,
          isNew: true,
          keepAlive: false,
        },
      },
      {
        path: "contentSynchronization/list/HEALTH_INTERVIEW",
        name: authCodeMap.newCom_content_synchronization_list_HEALTH_INTERVIEW,
        component: (): any => import("@/modules/newCommunity/pages/contentSynchronization/list.vue"),
        meta: {
          title: "内容同步_同步列表_科普专访列表",
          hidden: false,
          needLogin: true,
          articleType: "HEALTH_INTERVIEW",
          authCode: authCodeMap.newCom_content_synchronization_list_POPULAR_SCIENCE,
          isNew: true,
          keepAlive: false,
        },
      },
      {
        path: "contentSynchronization/list/PATHOLOGICAL_ANALYSIS",
        name: authCodeMap.newCom_content_synchronization_list_PATHOLOGICAL_ANALYSIS,
        component: (): any => import("@/modules/newCommunity/pages/contentSynchronization/list.vue"),
        meta: {
          title: "内容同步_同步列表_病例分析列表",
          hidden: false,
          needLogin: true,
          articleType: "PATHOLOGICAL_ANALYSIS",
          authCode: authCodeMap.newCom_content_synchronization_list_PATHOLOGICAL_ANALYSIS,
          isNew: true,
          keepAlive: false,
        },
      },
      {
        path: "contentSynchronization/list/DIARY",
        name: authCodeMap.newCom_content_synchronization_list_DIARY,
        component: (): any => import("@/modules/newCommunity/pages/contentSynchronization/list.vue"),
        meta: {
          title: "内容同步_同步列表_诊间日记列表",
          hidden: false,
          needLogin: true,
          articleType: "DIARY",
          authCode: authCodeMap.newCom_content_synchronization_list_DIARY,
          isNew: true,
          keepAlive: false,
        },
      },
      {
        path: "contentSynchronization/list",
        name: authCodeMap.newCom_content_synchronization_list,
        component: (): any => import("@/modules/newCommunity/pages/contentSynchronization/list.vue"),
        meta: {
          title: "内容同步_同步列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_synchronization_list,
          isNew: true,
          keepAlive: false,
        },
      },
      {
        path: "contentManage/specialTopic/list",
        name: authCodeMap.newCom_content_specialTopic_list,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/specialTopic/index.vue"),
        meta: {
          title: "内容管理_专题管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_specialTopic_list,
          isNew: true,
          // keepAlive: true,
        },
      },
      {
        path: "contentManage/specialTopic/edit",
        name: authCodeMap.newCom_content_specialTopic_edit,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/specialTopic/edit.vue"),
        meta: {
          title: "内容管理_专题管理_编辑",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_content_specialTopic_edit,
          isNew: true,
          // keepAlive: true,
        },
      },
      {
        path: "serviceManage/prescriptionOrder/list",
        name: authCodeMap.newCom_prescription_order_list,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/prescriptionOrder/list.vue"),
        meta: {
          title: "服务管理_处方记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_prescription_order_list,
          isNew: true,
        },
      },
      {
        path: "serviceManage/prescriptionOrder/list/info",
        name: authCodeMap.newCom_prescription_order_list_info,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/prescriptionOrder/info.vue"),
        meta: {
          title: "服务管理_处方单管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_prescription_order_list_info,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/list",
        name: authCodeMap.newCom_service_management_list,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/serviceSettings/quickPrescription/list.vue"),
        meta: {
          title: "服务管理_快捷处方",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_service_management_list,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/list/edit",
        name: authCodeMap.newCom_service_management_list_edit,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/serviceSettings/quickPrescription/edit.vue"),
        meta: {
          title: "服务管理_快捷处方_编辑",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_service_management_list_edit,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/serviceList/graphicConsultation",
        name: authCodeMap.newCom_service_management_graphic_consultation,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/serviceSettings/serviceList/index.vue"),
        meta: {
          title: "服务管理_图文咨询",
          hidden: false,
          needLogin: true,
          type: "graphicConsultation",
          authCode: authCodeMap.newCom_service_management_graphic_consultation,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/inquiryOrderManage/graphicConsultation",
        name: authCodeMap.newCom_service_management_inquiry_order_manage_graphic_consultation,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/serviceSettings/serviceList/inquiryOrder.vue"),
        meta: {
          title: "服务管理_图文咨询_咨询单管理",
          hidden: false,
          needLogin: true,
          type: "graphicConsultation",
          authCode: authCodeMap.newCom_service_management_inquiry_order_manage_graphic_consultation,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/communicationManage/graphicConsultation",
        name: authCodeMap.newCom_service_management_communicationManage_graphic_consultation,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/communicationManage/index.vue"),
        meta: {
          title: "服务管理_图文咨询_传播管理",
          hidden: false,
          needLogin: true,
          type: "graphicConsultation",
          authCode: authCodeMap.newCom_service_management_communicationManage_graphic_consultation,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/serviceList/rapidPrescribing",
        name: authCodeMap.newCom_service_management_rapid_prescribing,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/serviceSettings/serviceList/index.vue"),
        meta: {
          title: "服务管理_快速开药",
          hidden: false,
          needLogin: true,
          type: "rapidPrescribing",
          authCode: authCodeMap.newCom_service_management_rapid_prescribing,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/inquiryOrderManage/rapidPrescribing",
        name: authCodeMap.newCom_service_management_inquiry_order_manage_rapid_prescribing,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/serviceSettings/serviceList/inquiryOrder.vue"),
        meta: {
          title: "服务管理_快速开药_咨询单管理",
          hidden: false,
          needLogin: true,
          type: "rapidPrescribing",
          authCode: authCodeMap.newCom_service_management_inquiry_order_manage_rapid_prescribing,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/communicationManage/rapidPrescribing",
        name: authCodeMap.newCom_service_management_communicationManage_rapid_prescribing,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/communicationManage/index.vue"),
        meta: {
          title: "服务管理_快速开药_传播管理",
          hidden: false,
          needLogin: true,
          type: "rapidPrescribing",
          authCode: authCodeMap.newCom_service_management_communicationManage_rapid_prescribing,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/serviceList/telephoneConsultation",
        name: authCodeMap.newCom_service_management_telephone_consultation,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/serviceSettings/serviceList/index.vue"),
        meta: {
          title: "服务管理_电话咨询",
          hidden: false,
          needLogin: true,
          type: "telephoneConsultation",
          authCode: authCodeMap.newCom_service_management_telephone_consultation,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/inquiryOrderManage/telephoneConsultation",
        name: authCodeMap.newCom_service_management_inquiry_order_manage_telephone_consultation,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/serviceSettings/serviceList/inquiryOrder.vue"),
        meta: {
          title: "服务管理_电话咨询_咨询单管理",
          hidden: false,
          needLogin: true,
          type: "telephoneConsultation",
          authCode: authCodeMap.newCom_service_management_inquiry_order_manage_telephone_consultation,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/communicationManage/telephoneConsultation",
        name: authCodeMap.newCom_service_management_communicationManage_telephone_consultation,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/communicationManage/index.vue"),
        meta: {
          title: "服务管理_电话咨询_传播管理",
          hidden: false,
          needLogin: true,
          type: "telephoneConsultation",
          authCode: authCodeMap.newCom_service_management_communicationManage_telephone_consultation,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/communicationManage/offline",
        name: authCodeMap.newCom_service_management_communicationManage_offline,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/communicationManage/index.vue"),
        meta: {
          title: "服务管理_线下面诊_传播管理",
          hidden: false,
          needLogin: true,
          type: "offline",
          authCode: authCodeMap.newCom_service_management_communicationManage_offline,
          isNew: true,
        },
      },
      {
        path: "serviceManage/serviceSettings/communicationManage/detection",
        name: authCodeMap.newCom_service_management_communicationManage_detection,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/communicationManage/index.vue"),
        meta: {
          title: "服务管理_基因检测_传播管理",
          hidden: false,
          needLogin: true,
          type: "offline",
          authCode: authCodeMap.newCom_service_management_communicationManage_detection,
          isNew: true,
        },
      },
      // {
      //   path: "serviceManage/inquiryOrderManage",
      //   name: authCodeMap.newCom_service_management_inquiry_order_manage,
      //   component: (): any => import("@/modules/newCommunity/pages/serviceManage/inquiryOrderManage/index.vue"),
      //   meta: {
      //     title: "服务管理_服务记录_咨询单管理",
      //     hidden: false,
      //     needLogin: true,
      //     authCode: authCodeMap.newCom_service_management_inquiry_order_manage,
      //     isNew: true,
      //     keepAlive: true,
      //   },
      // },
      // {
      //   path: "serviceManage/inquiryOrderManage/detail",
      //   name: authCodeMap.newCom_service_management_inquiry_order_manage_detail,
      //   component: (): any => import("@/modules/newCommunity/pages/serviceManage/inquiryOrderManage/orderDetail.vue"),
      //   meta: {
      //     title: "服务管理_服务记录_咨询单管理_详情",
      //     hidden: false,
      //     needLogin: true,
      //     authCode: authCodeMap.newCom_service_management_inquiry_order_manage_detail,
      //     isNew: true,
      //   },
      // },
      {
        path: "serviceManage/prescriptionTemplateManage/CreatePrescriptionTemplatePage",
        name: authCodeMap.newCom_serviceManage_prescriptionTemplateManage_CreatePrescriptionTemplatePage,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/prescriptionTemplateManage/CreatePrescriptionTemplatePage.vue"),
        meta: {
          title: "服务管理_处方模板_新建模板",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_serviceManage_prescriptionTemplateManage_CreatePrescriptionTemplatePage,
          isNew: true,
        },
      },
      {
        path: "serviceManage/prescriptionTemplateManage/PrescriptionTemplateManagePage",
        name: authCodeMap.newCom_serviceManage_prescriptionTemplateManage_PrescriptionTemplateManagePage,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/prescriptionTemplateManage/PrescriptionTemplateManagePage.vue"),
        meta: {
          title: "服务管理_处方模板",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_serviceManage_prescriptionTemplateManage_PrescriptionTemplateManagePage,
          isNew: true,
        },
      },
      {
        path: "serviceManage/prescriptionTemplateManage/PrescriptionTemplateManagePage/distributeEdit",
        name: authCodeMap.newCom_distributeEdit,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/prescriptionTemplateManage/distributeEdit.vue"),
        meta: {
          title: "服务管理_处方模板_分发",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_distributeEdit,
          isNew: true,
        },
      },
      {
        path: "userManage/userList",
        name: authCodeMap.newCom_userManage_userList,
        component: (): any => import("@/modules/newCommunity/pages/userManage/userList.vue"),
        meta: {
          title: "用户管理_用户列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_userList,
          isNew: true,
        },
      },
      {
        path: "userManage/labelList",
        name: authCodeMap.newCom_userManage_labelList,
        component: (): any => import("@/modules/newCommunity/pages/userManage/labelList.vue"),
        meta: {
          title: "用户管理_标签管理_手动标签",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_labelList,
          isNew: true,
        },
      },
      {
        path: "userManage/autoLabelList",
        name: authCodeMap.newCom_userManage_autoLabelList,
        component: (): any => import("@/modules/newCommunity/pages/userManage/autoLabelList.vue"),
        meta: {
          title: "用户管理_标签管理_自动标签",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_autoLabelList,
          isNew: true,
        },
      },
      {
        path: "userManage/autoLabelList/addLabelGroup",
        name: authCodeMap.newCom_userManage_autoLabelList_addLabelGroup,
        component: (): any => import("@/modules/newCommunity/pages/userManage/addLabelGroup.vue"),
        meta: {
          title: "用户管理_标签管理_自动标签_新建标签组",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_autoLabelList_addLabelGroup,
          isNew: true,
        },
      },
      {
        path: "userManage/birthdayMessage",
        name: authCodeMap.newCom_userManage_birthdayMessage,
        component: (): any => import("@/modules/newCommunity/pages/userManage/birthdayMessage.vue"),
        meta: {
          title: "用户管理_用户关怀_生日关怀",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_birthdayMessage,
          isNew: true,
        },
      },
      {
        path: "userManage/userMessageEdit",
        name: authCodeMap.newCom_userManage_userMessageEdit,
        component: (): any => import("@/modules/newCommunity/pages/userManage/userMessageEdit.vue"),
        meta: {
          title: "用户管理_用户列表_新建推送",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_userMessageEdit,
          isNew: true,
        },
      },
      {
        path: "userManage/userMessageRecord",
        name: authCodeMap.newCom_userManage_userMessageRecord,
        component: (): any => import("@/modules/newCommunity/pages/userManage/userMessageRecord.vue"),
        meta: {
          title: "用户管理_用户列表_消息详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_userMessageRecord,
          isNew: true,
        },
      },
      {
        path: "userManage/userMessageRecordList",
        name: authCodeMap.newCom_userManage_userMessageRecordList,
        component: (): any => import("@/modules/newCommunity/pages/userManage/userMessageRecordList.vue"),
        meta: {
          title: "用户管理_用户列表_消息记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_userMessageRecordList,
          isNew: true,
        },
      },
      {
        path: "userManage/userGroupList",
        name: authCodeMap.newCom_userManage_userGroupList,
        component: (): any => import("@/modules/newCommunity/pages/userManage/userGroupList.vue"),
        meta: {
          title: "用户管理_用户分群",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_userGroupList,
          isNew: true,
        },
      },
      {
        path: "userManage/userGroupListEdit",
        name: authCodeMap.newCom_userManage_addGroup,
        component: (): any => import("@/modules/newCommunity/pages/userManage/useGroupEdit.vue"),
        meta: {
          title: "用户管理_用户分群-编辑",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_addGroup,
          isNew: true,
        },
      },
      {
        path: "doctorList/doctorRecommend",
        name: authCodeMap.newCom_doctorList_doctorRecommend,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/doctorRecommend.vue"),
        meta: {
          title: "医生管理_医生推荐",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorList_doctorRecommend,
          isNew: true,
        },
      },

      {
        path: "doctorList/doctorInfo",
        name: authCodeMap.newCom_doctorList_doctorInfo,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/doctorInfo.vue"),
        meta: {
          title: "医生管理_医生详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorList_doctorInfo,
          isNew: true,
        },
      },
      {
        path: "doctorList/doctorMessageEdit",
        name: authCodeMap.newCom_doctorList_doctorMessageEdit,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/doctorMessageEdit.vue"),
        meta: {
          title: "医生管理_医生列表_新建推送",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorList_doctorMessageEdit,
          isNew: true,
        },
      },
      {
        path: "doctorList/doctorPromotionManage",
        name: authCodeMap.newCom_doctorList_doctorPromotionManage,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/doctorPromotionManage.vue"),
        meta: {
          title: "医生列表_传播管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorList_doctorPromotionManage,
          isNew: true,
        },
      },
      {
        path: "doctorList/list",
        name: authCodeMap.newCom_doctorList_list,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/list.vue"),
        meta: {
          title: "医生管理_医生列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorList_list,
          isNew: true,
          keepAlive: true,
        },
      },
      {
        path: "doctorList/doctorSeatBudget",
        name: authCodeMap.newCom_doctorList_seatBudget,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/doctorSeatBudget.vue"),
        meta: {
          title: "医生管理_医生列表_预算账户",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorList_seatBudget,
          isNew: true,
          keepAlive: true,
        },
      },
      {
        path: "doctorList/labelList",
        name: authCodeMap.newCom_doctorList_labelList,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/labelList.vue"),
        meta: {
          title: "医生管理_医生标签管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorList_labelList,
          isNew: true,
        },
      },
      {
        path: "doctorList/doctorMessageRecord",
        name: authCodeMap.newCom_doctorList_doctorMessageRecord,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/doctorMessageRecord.vue"),
        meta: {
          title: "医生管理_消息记录_消息详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorList_doctorMessageRecord,
          isNew: true,
        },
      },
      {
        path: "doctorList/doctorMessageRecordList",
        name: authCodeMap.newCom_doctorList_doctorMessageRecordList,
        component: (): any => import("@/modules/newCommunity/pages/doctorList/doctorMessageRecordList.vue"),
        meta: {
          title: "医生管理_医生加入_消息记录",
          hidden: false,
          needLogin: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_doctorList_doctorMessageRecordList,
          isNew: true,
        },
      },
      {
        path: "doctorInvite/autoAuditSetting",
        name: authCodeMap.newCom_doctorManage_doctorJoin_auditRecord_autoAudit,
        component: (): any => import("@/modules/newCommunity/pages/doctorInvite/autoAuditSetting.vue"),
        meta: {
          title: "医生管理_医生加入_审核记录_自动审核加入",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorManage_doctorJoin_auditRecord_autoAudit,
          isNew: true,
        },
      },
      {
        path: "doctorInvite/auditRecord",
        name: authCodeMap.newCom_doctorInvite_auditRecord,
        component: (): any => import("@/modules/newCommunity/pages/doctorInvite/auditRecord.vue"),
        meta: {
          title: "医生管理_医生加入_审核管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorInvite_auditRecord,
          isNew: true,
        },
      },
      {
        path: "doctorInvite/inviteRecordAdd",
        name: authCodeMap.newCom_doctorInvite_inviteRecordAdd,
        component: (): any => import("@/modules/newCommunity/pages/doctorInvite/inviteRecordAdd.vue"),
        meta: {
          title: "医生管理_医生加入_邀请医生",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorInvite_inviteRecordAdd,
          isNew: true,
        },
      },
      {
        path: "doctorInvite/inviteRecord",
        name: authCodeMap.newCom_doctorInvite_inviteRecord,
        component: (): any => import("@/modules/newCommunity/pages/doctorInvite/inviteRecord.vue"),
        meta: {
          title: "医生管理_医生加入_邀请记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorInvite_inviteRecord,
          isNew: true,
          keepAlive: true,
        },
      },
      {
        path: "doctorInvite/gertificationRecord",
        name: authCodeMap.newCom_doctorInvite_gertificationRecord,
        component: (): any => import("@/modules/newCommunity/pages/doctorInvite/gertificationRecord.vue"),
        meta: {
          title: "医生管理_医生加入_认证记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorInvite_gertificationRecord,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_community_deco_index,
        name: authCodeMap.newCom_community_deco_index,
        component: (): any => import("@/modules/newCommunity/pages/communitySettings/home/homeSettings.vue"),
        meta: {
          title: "品牌社区_健康社区_社区装修",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_community_deco_index,
          isNew: true,
        },
      },
      {
        path: "communitySettings/miniprogramBind",
        name: authCodeMap.newCom_community_miniprogram_index,
        component: (): any => import("@/modules/newCommunity/pages/miniprogramBind/miniprogramBind.vue"),
        meta: {
          title: "品牌社区_健康社区_小程序绑定",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_community_miniprogram_index,
          isNew: true,
        },
      },
      {
        path: "communitySettings/communicationPromotion",
        name: authCodeMap.newCom_promotion,
        component: (): any => import("@/modules/newCommunity/pages/communicationPromotion/index.vue"),
        meta: {
          title: "品牌社区_健康社区_社区传播",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_promotion,
          isNew: true,
        },
      },
      {
        path: "dataManagement_basicInfo",
        name: authCodeMap.newCom_data_manage,
        component: (): any => import("@/modules/newCommunity/pages/dataManagement/index.vue"),
        meta: {
          title: "资料管理-社区基本信息",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_data_manage,
          isNew: true,
        },
      },
      {
        path: "dataManagement_infoEdit",
        name: authCodeMap.newCommunity_dataManagement_infoEdit,
        component: (): any => import("@/modules/newCommunity/pages/dataManagement/infoEdit.vue"),
        meta: {
          title: "资料管理-编辑社区信息",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCommunity_dataManagement_infoEdit,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_service_saleList,
        name: authCodeMap.newCom_service_saleList,
        redirect: authCodeMap.newCom_service_saleList_consult,
        meta: {
          title: "销售记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_service_saleList,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_service_saleList_consult,
        name: authCodeMap.newCom_service_saleList_consult,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/saleList/consultList.vue"),
        meta: {
          title: "咨询记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_service_saleList_consult,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_service_saleList_offline,
        name: authCodeMap.newCom_service_saleList_offline,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/saleList/offlineList.vue"),
        meta: {
          title: "面诊记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_service_saleList_offline,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_service_saleList_product,
        name: authCodeMap.newCom_service_saleList_product,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/saleList/productList.vue"),
        meta: {
          title: "商品记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_service_saleList_product,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_appointmentStore,
        name: authCodeMap.newCom_appointmentStore,
        redirect: authCodeMap.newCom_appointmentStore_setting,
        meta: {
          title: "预约到店",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_appointmentStore_setting,
        name: authCodeMap.newCom_appointmentStore_setting,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/appointmentStore/setting.vue"),
        meta: {
          title: "预约到店_服务设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore_setting,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_appointmentStore_serviceRecord,
        name: authCodeMap.newCom_appointmentStore_serviceRecord,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/appointmentStore/serviceRecord.vue"),
        meta: {
          title: "预约到店_服务记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore_serviceRecord,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_appointmentStore_serviceRecord_rebook,
        name: authCodeMap.newCom_appointmentStore_serviceRecord_rebook,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/appointmentStore/addRecord.vue"),
        meta: {
          title: "预约到店_服务记录_新增预约",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore_serviceRecord_rebook,
          isNew: true,
        },
      },
      {
        path: "yixingConfirmRecord",
        name: "yixingConfirmRecord",
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/appointmentStore/confirmRecord.vue"),
        meta: {
          title: "预约到店_服务记录_确认预约",
          hidden: false,
          needLogin: true,
          // authCode: authCodeMap.newCom_appointmentStore_serviceRecord_rebook,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_appointmentStore_serviceRecord_edit,
        name: authCodeMap.newCom_appointmentStore_serviceRecord_edit,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/appointmentStore/addRecord.vue"),
        meta: {
          title: "预约到店_服务记录_修改预约",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore_serviceRecord_edit,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_appointmentStore_serviceRecord_view,
        name: authCodeMap.newCom_appointmentStore_serviceRecord_view,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/appointmentStore/serviceRecordInfo.vue"),
        meta: {
          title: "预约到店_服务记录_详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore_serviceRecord_view,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_appointmentStore_communicationManage,
        name: authCodeMap.newCom_appointmentStore_communicationManage,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/communicationManage/index.vue"),
        meta: {
          title: "预约到店_传播管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore_communicationManage,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_appointmentStore_storeInfo,
        name: authCodeMap.newCom_appointmentStore_storeInfo,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/appointmentStore/storeInfo.vue"),
        meta: {
          title: "预约到店_门店信息",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore_storeInfo,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_appointmentStore_storeInfoView,
        name: authCodeMap.newCom_appointmentStore_storeInfoView,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/appointmentStore/storeInfoView.vue"),
        meta: {
          title: "预约到店_门店信息",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_appointmentStore_storeInfoView,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_comtySetting_store,
        name: authCodeMap.newCom_comtySetting_store,
        component: (): any => import("@/modules/newCommunity/pages/storeInfo/index.vue"),
        meta: {
          title: "门店信息",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_comtySetting_store,
          isNew: true,
        },
      },
      {
        path: "comtySetting_store_edit",
        name: authCodeMap.newCom_comtySetting_store_edit,
        component: (): any => import("@/modules/newCommunity/pages/storeInfo/edit.vue"),
        meta: {
          title: "编辑门店信息",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_comtySetting_store_edit,
          isNew: true,
        },
      },
      {
        path: "home",
        name: authCodeMap.newCom_home,
        component: (): any => import("@/modules/newCommunity/pages/home/index.vue"),
        meta: {
          hidden: true,
          needLogin: true,
          title: "社区首页",
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_sales,
        name: authCodeMap.newCom_drug_manage_sales,
        component: (): any => import("@/modules/newCommunity/pages/serviceManage/saleList/productList.vue"),
        meta: {
          title: "社区设置_药品管理_药品销售管理",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_sales,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_distribution_by_goods,
        name: authCodeMap.newCom_drug_manage_distribution_by_goods,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/distributionManagement/byGoods/index.vue"),
        meta: {
          title: "社区设置_药品管理_药品分发管理_按商品分发",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_distribution_by_goods,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_distribution_by_doctor,
        name: authCodeMap.newCom_drug_manage_distribution_by_doctor,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/distributionManagement/byDoctor/index.vue"),
        meta: {
          title: "社区设置_药品管理_药品分发管理_按医生分发",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_distribution_by_doctor,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_deployment_record,
        name: authCodeMap.newCom_drug_manage_deployment_record,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/deploymentManagement/deploymentRocord/index.vue"),
        meta: {
          title: "社区设置_药品管理_药品投放管理_投放记录",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_deployment_record,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_deployment_data,
        name: authCodeMap.newCom_drug_manage_deployment_data,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/deploymentManagement/deploymentData/index.vue"),
        meta: {
          title: "社区设置_药品管理_药品投放管理_投放数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_deployment_data,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_deployment_sample_request,
        name: authCodeMap.newCom_drug_manage_deployment_sample_request,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/deploymentManagement/sampleRequest/index.vue"),
        meta: {
          title: "社区设置_药品管理_药品投放管理_样品申领",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_deployment_sample_request,
          isNew: true,
        },
      },
      {
        path: authCodeMap.DeploymentManage_Record_add,
        name: authCodeMap.DeploymentManage_Record_add,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/deploymentManagement/deploymentRocord/deploymentDetail.vue"),
        meta: {
          title: "社区设置_药品管理_药品投放管理_投放记录_新增投放",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.DeploymentManage_Record_add,
          isNew: true,
        },
      },
      {
        path: authCodeMap.DeploymentManage_Record_detail,
        name: authCodeMap.DeploymentManage_Record_detail,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/deploymentManagement/deploymentRocord/deploymentDetail.vue"),
        meta: {
          title: "社区设置_药品管理_药品投放管理_投放记录_投放详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.DeploymentManage_Record_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.DeploymentManage_Sample_detail,
        name: authCodeMap.DeploymentManage_Sample_detail,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/deploymentManagement/sampleRequest/detail.vue"),
        meta: {
          title: "社区设置_药品管理_药品投放管理_样品申领_详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.DeploymentManage_Sample_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.DeploymentManage_RecordData_detail,
        name: authCodeMap.DeploymentManage_RecordData_detail,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/deploymentManagement/deploymentData/detail.vue"),
        meta: {
          title: "社区设置_药品管理_药品投放管理_投放数据_详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.DeploymentManage_RecordData_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_operate_records,
        name: authCodeMap.newCom_drug_manage_operate_records,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/distributionManagement/byDoctor/operateRecords.vue"),
        meta: {
          title: "社区设置_药品管理_药品分发管理_操作记录",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_operate_records,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_inventory,
        name: authCodeMap.newCom_drug_manage_inventory,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/inventoryManagement/index.vue"),
        meta: {
          title: "社区设置_药品管理_药品库管理",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_inventory,
          isNew: true,
        },
      },
      // {
      //   path: authCodeMap.newCom_drug_manage_medication_reminder,
      //   name: authCodeMap.newCom_drug_manage_medication_reminder,
      //   component: (): any => import("@/modules/newCommunity/pages/drugManagement/medicationReminder/index.vue"),
      //   meta: {
      //     title: "社区设置_药品管理_用药提醒设置",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.newCom_drug_manage_medication_reminder,
      //     isNew: true,
      //   },
      // },
      {
        path: authCodeMap.newCom_drug_manage_medication_reminder_medication,
        name: authCodeMap.newCom_drug_manage_medication_reminder_medication,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/medicationReminder/index.vue"),
        meta: {
          title: "社区设置_药品管理_用药提醒设置_用药指导",
          hidden: true,
          needLogin: true,
          type: "medication",
          authCode: authCodeMap.newCom_drug_manage_medication_reminder_medication,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_medication_reminder_care,
        name: authCodeMap.newCom_drug_manage_medication_reminder_care,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/medicationReminder/index.vue"),
        meta: {
          title: "社区设置_药品管理_用药提醒设置_用药关怀",
          hidden: true,
          needLogin: true,
          type: "care",
          authCode: authCodeMap.newCom_drug_manage_medication_reminder_care,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_medication_reminder_contMedication,
        name: authCodeMap.newCom_drug_manage_medication_reminder_contMedication,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/medicationReminder/index.vue"),
        meta: {
          title: "社区设置_药品管理_用药提醒设置_续方提醒",
          hidden: true,
          needLogin: true,
          type: "contMedication",
          authCode: authCodeMap.newCom_drug_manage_medication_reminder_contMedication,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_recommendations_list,
        name: authCodeMap.newCom_drug_manage_recommendations_list,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/drugRecommendations/index.vue"),
        meta: {
          title: "社区设置_药品管理_健康优选列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_recommendations_list,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_recommendations_communicationManage,
        name: authCodeMap.newCom_drug_manage_recommendations_communicationManage,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/drugRecommendations/communication.vue"),
        meta: {
          title: "社区设置_药品管理_健康优选_传播管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_recommendations_communicationManage,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_healthshoppingmall_list,
        name: authCodeMap.newCom_drug_manage_healthshoppingmall_list,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/shoppingMall/index.vue"),
        meta: {
          title: "社区设置_药品管理_便民药房_列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_healthshoppingmall_list,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_healthshoppingmall_dissemination_detail,
        name: authCodeMap.newCom_drug_manage_healthshoppingmall_dissemination_detail,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/shoppingMall/goodsCommunication.vue"),
        meta: {
          title: "社区设置_药品管理_便民药房_商品传播详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_healthshoppingmall_dissemination_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_healthshoppingmall_communicationManage,
        name: authCodeMap.newCom_drug_manage_healthshoppingmall_communicationManage,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/shoppingMall/communication.vue"),
        meta: {
          title: "社区设置_药品管理_健康优选_传播管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_healthshoppingmall_communicationManage,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollection,
        name: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollection,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/shoppingMall/productCollection.vue"),
        meta: {
          title: "健康服务_药房_便民药房_商品合集",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollection,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollectiondetail,
        name: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollectiondetail,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/shoppingMall/productCollectionDetail.vue"),
        meta: {
          title: "健康服务_药房_便民药房_商品合集_详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollectiondetail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollectiondisseminate,
        name: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollectiondisseminate,
        component: (): any => import("@/modules/newCommunity/pages/drugManagement/shoppingMall/productionCommunication.vue"),
        meta: {
          title: "健康服务_药房_便民药房_商品合集_详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_drug_manage_healthshoppingmall_productcollectiondisseminate,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_contentManage_labelList,
        name: authCodeMap.newCom_contentManage_labelList,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/labelList.vue"),
        meta: {
          title: "内容管理_内容标签",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_contentManage_labelList,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_contentManage_contentList,
        name: authCodeMap.newCom_contentManage_contentList,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/contentList.vue"),
        meta: {
          title: "内容管理_内容创作_创作列表",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_contentManage_contentList,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_contentManage_contentList_NEWS,
        name: authCodeMap.newCom_contentManage_contentList_NEWS,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/contentList.vue"),
        meta: {
          title: "内容管理_内容创作_新闻咨询列表",
          hidden: true,
          needLogin: true,
          articleType: "NEWS",
          authCode: authCodeMap.newCom_contentManage_contentList_NEWS,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_contentManage_contentList_POPULAR_SCIENCE,
        name: authCodeMap.newCom_contentManage_contentList_POPULAR_SCIENCE,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/contentList.vue"),
        meta: {
          title: "内容管理_内容创作_科普文章列表",
          hidden: true,
          needLogin: true,
          articleType: "POPULAR_SCIENCE",
          authCode: authCodeMap.newCom_contentManage_contentList_POPULAR_SCIENCE,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_contentManage_contentList_VIDEO,
        name: authCodeMap.newCom_contentManage_contentList_VIDEO,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/contentList.vue"),
        meta: {
          title: "内容管理_内容创作_科普视频列表",
          hidden: true,
          needLogin: true,
          articleType: "VIDEO",
          authCode: authCodeMap.newCom_contentManage_contentList_VIDEO,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_contentManage_contentEdit,
        name: authCodeMap.newCom_contentManage_contentEdit,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/contentEdit.vue"),
        meta: {
          title: "内容管理_内容创作_创作编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_contentManage_contentEdit,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_contentManage_authorEdit,
        name: authCodeMap.newCom_contentManage_authorEdit,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/authorEdit.vue"),
        meta: {
          title: "内容管理_内容创作_内容作者管理_创建内容作者",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_contentManage_authorEdit,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_contentManage_authorList,
        name: authCodeMap.newCom_contentManage_authorList,
        component: (): any => import("@/modules/newCommunity/pages/contentManage/authorList.vue"),
        meta: {
          title: "内容管理_内容创作_内容作者管理",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_contentManage_authorList,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_surveyActivity_edit,
        name: authCodeMap.newCom_newActivityManage_surveyActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_surveyActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_edit,
        name: authCodeMap.newCom_newActivityManage_streamActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_edit,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/editPage.vue"),
        meta: {
          title: "医学讲堂活动_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_consultActivity_edit,
        name: authCodeMap.newCom_newActivityManage_consultActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_consultActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_answerActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_answerActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          isBudgetSystemWhiteList: true,

          authCode: authCodeMap.newCom_newActivityManage_answerActivity_activityList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityAnswerManage_rewardList,
        name: authCodeMap.newCom_newActivityAnswerManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/rewardList.vue"),
        meta: {
          title: "互动答题-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,

          authCode: authCodeMap.newCom_newActivityAnswerManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_caseActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_caseActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_caseActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_reviewsActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_reviewsActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_reviewsActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_expertAnswerActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_expertAnswerActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/activitySettingPage.vue"),
        meta: {
          title: "活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/activitySettingPage.vue"),
        meta: {
          title: "活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_liveActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_medicalMeetActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_liveActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/activitySettingPage.vue"),
        meta: {
          title: "公益讲堂_活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_medicalMeetActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/activitySettingPage.vue"),
        meta: {
          title: "公益讲堂_活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_surveyActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_surveyActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          isBudgetSystemWhiteList: true,

          authCode: authCodeMap.newCom_newActivityManage_surveyActivity_activityList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_surveyActivity_detail,
        name: authCodeMap.newCom_newActivityManage_surveyActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_surveyActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_streamActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          isBudgetSystemWhiteList: true,

          authCode: authCodeMap.newCom_newActivityManage_streamActivity_activityList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_streamActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/activitySettingPage.vue"),
        meta: {
          title: "新公益讲堂_活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/activityListPage.vue"),
        meta: {
          title: "医学讲堂活动_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          isBudgetSystemWhiteList: true,

          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_activityList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_detail,
        name: authCodeMap.newCom_newActivityManage_streamActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_detail,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/activityDetailPage.vue"),
        meta: {
          title: "医学讲堂活动_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_consultActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_consultActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          isBudgetSystemWhiteList: true,

          authCode: authCodeMap.newCom_newActivityManage_consultActivity_activityList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_consultActivity_detail,
        name: authCodeMap.newCom_newActivityManage_consultActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_consultActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_caseActivity_detail,
        name: authCodeMap.newCom_newActivityManage_caseActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_caseActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_reviewsActivity_detail,
        name: authCodeMap.newCom_newActivityManage_reviewsActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_reviewsActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_reviewsActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_reviewsActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/activitySettingPage.vue"),
        meta: {
          title: "点评活动_活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_reviewsActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_detail,
        name: authCodeMap.newCom_newActivityManage_expertAnswerActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_detail,
        name: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_detail,
        name: authCodeMap.newCom_newActivityManage_liveActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_detail,
        name: authCodeMap.newCom_newActivityManage_medicalMeetActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_answerActivity_detail,
        name: authCodeMap.newCom_newActivityManage_answerActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_answerActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivitySurveyManage_rewardList,
        name: authCodeMap.newCom_newActivitySurveyManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivitySurveyManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivitystreamManage_rewardList,
        name: authCodeMap.newCom_newActivitystreamManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivitystreamManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityMedicalStreamManage_rewardList,
        name: authCodeMap.newCom_newActivityMedicalStreamManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityMedicalStreamManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityConsultManage_rewardList,
        name: authCodeMap.newCom_newActivityConsultManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityConsultManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityCaseManage_rewardList,
        name: authCodeMap.newCom_newActivityCaseManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityCaseManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityReviewsManage_rewardList,
        name: authCodeMap.newCom_newActivityReviewsManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityReviewsManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityExpertAnswerManage_rewardList,
        name: authCodeMap.newCom_newActivityExpertAnswerManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityExpertAnswerManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityDoctorQuestionManage_rewardList,
        name: authCodeMap.newCom_newActivityDoctorQuestionManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityDoctorQuestionManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityLiveManage_rewardList,
        name: authCodeMap.newCom_newActivityLiveManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityLiveManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityMedicalMeetManage_rewardList,
        name: authCodeMap.newCom_newActivityMedicalMeetManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityMedicalMeetManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityAnswerManage_rewardList,
        name: authCodeMap.newCom_newActivityAnswerManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityAnswerManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_edit,
        name: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_edit,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularEditPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_surveyActivity_edit,
        name: authCodeMap.newCom_newActivityManage_surveyActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_surveyActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_edit,
        name: authCodeMap.newCom_newActivityManage_streamActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_edit,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/editPage.vue"),
        meta: {
          title: "医学讲堂活动_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_consultActivity_edit,
        name: authCodeMap.newCom_newActivityManage_consultActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_consultActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_caseActivity_edit,
        name: authCodeMap.newCom_newActivityManage_caseActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_caseActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_reviewsActivity_edit,
        name: authCodeMap.newCom_newActivityManage_reviewsActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_reviewsActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_reviewsActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_reviewsActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_任务明细汇总",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_reviewsActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_reviewsActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_reviewsActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_reviewsActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_edit,
        name: authCodeMap.newCom_newActivityManage_expertAnswerActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_expertAnswerActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_任务明细汇总",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_expertAnswerActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_questionAnswerManageList,
        name: authCodeMap.newCom_newActivityManage_expertAnswerActivity_questionAnswerManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/questionManageListPage.vue"),
        meta: {
          title: "活动管理_问答管理列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_questionAnswerManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_questionAnswerManageList,
        name: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_questionAnswerManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/questionManageListPage.vue"),
        meta: {
          title: "活动管理_问答管理列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_questionAnswerManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_expertAnswerActivity_rewardList,
        name: authCodeMap.newCom_newActivityManage_expertAnswerActivity_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/expertAnswerActivityManage/rewardListPage.vue"),
        meta: {
          title: "咖答活动-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_expertAnswerActivity_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_edit,
        name: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_任务明细汇总",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/doctorQuestionActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorQuestionActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_edit,
        name: authCodeMap.newCom_newActivityManage_liveActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_edit,
        name: authCodeMap.newCom_newActivityManage_medicalMeetActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_answerActivity_edit,
        name: authCodeMap.newCom_newActivityManage_answerActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_answerActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },

      {
        path: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          keepAlive: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },

      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularActivityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_interviewActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_interviewActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/activityListPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_interviewActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_interviewActivity_edit,
        name: authCodeMap.newCom_newActivityManage_interviewActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/editPage.vue"),
        meta: {
          title: "活动管理_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_interviewActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_interviewActivity_detail,
        name: authCodeMap.newCom_newActivityManage_interviewActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_interviewActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_interviewActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_interviewActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_interviewActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_interviewActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_interviewActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_interviewActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_interviewActivity_taskPreparationManage,
        name: authCodeMap.newCom_newActivityManage_interviewActivity_taskPreparationManage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/taskPreparationManagePage.vue"),
        meta: {
          title: "活动管理_任务准备管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_interviewActivity_taskPreparationManage,
        },
      },
      {
        path: authCodeMap.newCom_newActivityinterviewManage_rewardList,
        name: authCodeMap.newCom_newActivityinterviewManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityinterviewManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/commonSetting/popularSettingPage.vue"),
        meta: {
          title: "活动管理_活动列表_设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/commonSetting/medicalSettingPage.vue"),
        meta: {
          title: "活动管理_活动列表_设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_caseActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_caseActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/activitySettingPage.vue"),
        meta: {
          title: "病例征集_活动列表_设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_caseActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_rewardList,
        name: authCodeMap.newCom_newActivityManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularRewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_rewardList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityMedicalManage_rewardList,
        name: authCodeMap.newCom_newActivityMedicalManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/rewardListPage.vue"),
        meta: {
          title: "活动征集-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityMedicalManage_rewardList,
        },
      },
      {
        path: authCodeMap.activityManage_doctorActivityManage_list_forNewComty,
        name: authCodeMap.activityManage_doctorActivityManage_list_forNewComty,
        component: (): any => import("@/modules/activityManage/pages/doctorActivityManage/activityListForNewComty.vue"),
        meta: {
          title: "运营_邀约管理_活动邀约（旧）",
          hidden: true,
          needLogin: true,
          isNew: true,

          authCode: authCodeMap.activityManage_doctorActivityManage_list_forNewComty,
        },
      },
      {
        path: authCodeMap.activityManage_doctorActivityManage_detail_forNewComty,
        name: authCodeMap.activityManage_doctorActivityManage_detail_forNewComty,
        component: (): any => import("@/modules/activityManage/pages/doctorActivityManage/activityDetailForNewComty.vue"),
        meta: {
          title: "运营_邀约管理_活动邀约（旧）",
          hidden: true,
          needLogin: true,
          isNew: true,

          authCode: authCodeMap.activityManage_doctorActivityManage_detail_forNewComty,
        },
      },
      {
        path: authCodeMap.activityManage_doctorActivityManage_manageList_forNewComty,
        name: authCodeMap.activityManage_doctorActivityManage_manageList_forNewComty,
        component: (): any => import("@/modules/activityManage/pages/doctorActivityManage/activityManageListForNewComty.vue"),
        meta: {
          title: "运营_邀约管理_活动邀约（旧）",
          hidden: true,
          needLogin: true,
          isNew: true,

          authCode: authCodeMap.activityManage_doctorActivityManage_manageList_forNewComty,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_inviteDoctor,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_inviteDoctor,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/inviteDoctor/invite.vue"),
        meta: {
          title: "活动管理_活动列表_邀约医生",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_inviteDoctor,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_detail,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularActivityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表_活动详情",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_detail,
        name: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/activityDetailPage.vue"),
        meta: {
          title: "活动管理_活动列表_活动详情",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularSubmissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_manageList,
        },
      },

      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_medical_activity_revisionManagementList,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_medical_activity_revisionManagementList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/revisionManagement/medical_activity_revisionManagementList.vue"),
        meta: {
          title: "审订建议管理",
          hidden: true,
          needLogin: true,
          isHidden: true,

          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_medical_activity_revisionManagementList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_popular_activity_revisionManagementList,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_popular_activity_revisionManagementList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/revisionManagement/popular_activity_revisionManagementList.vue"),
        meta: {
          title: "审订建议管理",
          hidden: true,
          isHidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_popular_activity_revisionManagementList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularApplyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorActivity_taskPreparationManage,
        name: authCodeMap.newCom_newActivityManage_doctorActivity_taskPreparationManage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/popularTaskPreparationManagePage.vue"),
        meta: {
          title: "科普投稿_任务准备管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorActivity_taskPreparationManage,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_doctorMedicalActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_surveyActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_surveyActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_surveyActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_surveyActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_surveyActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_surveyActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_surveyActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_surveyActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/activitySettingPage.vue"),
        meta: {
          title: "问卷调研_活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_surveyActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_streamActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/submissionManagePage.vue"),
        meta: {
          title: "医学讲堂活动_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_commonSetting,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_commonSetting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/activitySettingPage.vue"),
        meta: {
          title: "医学讲堂_活动列表_活动设置",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_commonSetting,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_manageList_batchImportVideo,
        name: authCodeMap.newCom_newActivityManage_streamActivity_manageList_batchImportVideo,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/batchImportVideo.vue"),
        meta: {
          title: "批量导入审订",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_manageList_batchImportVideo,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_manageList_batchImportVideo,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_manageList_batchImportVideo,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/batchImportVideo.vue"),
        meta: {
          title: "医学讲堂活动_批量导入审订",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_manageList_batchImportVideo,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_streamActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/applyManageListPage.vue"),
        meta: {
          title: "医学讲堂活动_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_taskPreparationManage,
        name: authCodeMap.newCom_newActivityManage_streamActivity_taskPreparationManage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/taskPreparationManagePage.vue"),
        meta: {
          title: "活动管理_任务准备管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_taskPreparationManage,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_taskPreparationManage,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_taskPreparationManage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalStreamActivityManage/taskPreparationManagePage.vue"),
        meta: {
          title: "医学讲堂活动_任务准备管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_taskPreparationManage,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_streamActivity_liveRoomInfo,
        name: authCodeMap.newCom_newActivityManage_streamActivity_liveRoomInfo,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/manageListComponents/liveRoomInfo.vue"),
        meta: {
          title: "活动管理_直播管理_直播间信息",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_streamActivity_liveRoomInfo,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalStreamActivity_liveRoomInfo,
        name: authCodeMap.newCom_newActivityManage_medicalStreamActivity_liveRoomInfo,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/manageListComponents/liveRoomInfo.vue"),
        meta: {
          title: "医学讲堂活动_直播管理_直播间信息",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalStreamActivity_liveRoomInfo,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_consultActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_consultActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_consultActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_consultActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_consultActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/consultActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_consultActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_caseActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_caseActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_caseActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_caseActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_caseActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/caseActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_caseActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_liveActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_medicalMeetActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_liveActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_liveActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/liveActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_liveActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_medicalMeetActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_medicalMeetActivity_medicalMeetRequestManagement,
        name: authCodeMap.newCom_newActivityManage_medicalMeetActivity_medicalMeetRequestManagement,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalMeetActivityManage/medicalMeetRequestManagement/index.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_medicalMeetActivity_medicalMeetRequestManagement,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_answerActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_answerActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/submissionManagePage.vue"),
        meta: {
          title: "活动管理_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_answerActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_answerActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_answerActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/answerActivityManage/applyManageListPage.vue"),
        meta: {
          title: "活动管理_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_answerActivity_applyManageList,
        },
      },
      // {
      //   path: authCodeMap.newCom_financeManage,
      //   name: authCodeMap.newCom_financeManage,
      //   component: (): any => import("@/modules/newCommunity/pages/finance/index/newIndex.vue"),
      //   meta: {
      //     title: "财务管理",
      //     hidden: true,
      //     needLogin: true,
      //     isNew: true,
      //     authCode: authCodeMap.newCom_financeManage,
      //   },
      // },
      {
        path: authCodeMap.newCom_financeManage_main_account,
        name: authCodeMap.newCom_financeManage_main_account,
        component: (): any => import("@/modules/newCommunity/pages/finance/index/mianIndex.vue"),
        meta: {
          title: "财务管理-主账号",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_financeManage_main_account,
        },
      },
      {
        path: authCodeMap.newCom_financeManage_divide_manage,
        name: authCodeMap.newCom_financeManage_divide_manage,
        component: (): any => import("@/modules/newCommunity/pages/finance/index/divideManage.vue"),
        meta: {
          title: "财务-分成管理",
          hidden: false,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_financeManage_divide_manage,
        },
      },
      {
        path: authCodeMap.newCom_financeManage_budget_account,
        name: authCodeMap.newCom_financeManage_budget_account,
        component: (): any => import("@/modules/newCommunity/pages/finance/index/budgetIndex.vue"),
        meta: {
          title: "财务管理-预算账号",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_financeManage_budget_account,
        },
      },
      {
        path: authCodeMap.newCom_financeManage_budget_accoun_list,
        name: authCodeMap.newCom_financeManage_budget_accoun_list,
        component: (): any => import("@/modules/newCommunity/pages/finance/index/budgetList.vue"),
        meta: {
          title: "财务管理-预算账号明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_financeManage_budget_accoun_list,
        },
      },
      {
        path: "doctorComty/contentManage/list",
        name: authCodeMap.newCom_doctorComty_content_management_list,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/list.vue"),
        meta: {
          title: "医生社区-内容管理-内容管理列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_content_management_list,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/list/MEDICAL_NEWS",
        name: authCodeMap.newCom_doctorComty_content_management_list_MEDICAL_NEWS,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/list.vue"),
        meta: {
          title: "医生社区-内容管理-内容管理列表_新闻资讯列表",
          hidden: false,
          needLogin: true,
          articleType: "MEDICAL_NEWS",
          authCode: authCodeMap.newCom_doctorComty_content_management_list_MEDICAL_NEWS,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/list/LEARNING",
        name: authCodeMap.newCom_doctorComty_content_management_list_LEARNING,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/list.vue"),
        meta: {
          title: "医生社区-内容管理-内容管理列表_医学文章",
          hidden: false,
          needLogin: true,
          articleType: "LEARNING",
          authCode: authCodeMap.newCom_doctorComty_content_management_list_LEARNING,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/list/ORIGINAL_REVIEWED_CONTENT",
        name: authCodeMap.newCom_doctorComty_content_management_list_ORIGINAL_REVIEWED_CONTENT,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/list.vue"),
        meta: {
          title: "医生社区-内容管理-内容管理列表_医学点评",
          hidden: false,
          needLogin: true,
          articleType: "ORIGINAL_REVIEWED_CONTENT",
          authCode: authCodeMap.newCom_doctorComty_content_management_list_ORIGINAL_REVIEWED_CONTENT,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/list/DOCTOR_QUESTION_EXPERT_ANSWER",
        name: authCodeMap.newCom_doctorComty_content_management_list_DOCTOR_QUESTION_EXPERT_ANSWER,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/list.vue"),
        meta: {
          title: "医生社区-内容管理-内容管理列表_医问咖答",
          hidden: false,
          needLogin: true,
          articleType: "DOCTOR_QUESTION_EXPERT_ANSWER",
          authCode: authCodeMap.newCom_doctorComty_content_management_list_DOCTOR_QUESTION_EXPERT_ANSWER,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/list/MEDICAL_VIDEO",
        name: authCodeMap.newCom_doctorComty_content_management_list_MEDICAL_VIDEO,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/list.vue"),
        meta: {
          title: "医生社区-内容管理-内容管理列表_医学视频",
          hidden: false,
          needLogin: true,
          articleType: "MEDICAL_VIDEO",
          authCode: authCodeMap.newCom_doctorComty_content_management_list_MEDICAL_VIDEO,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/list/LIVE_MEDICAL_CLASSROOM",
        name: authCodeMap.newCom_doctorComty_content_management_list_LIVE_MEDICAL_CLASSROOM,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/list.vue"),
        meta: {
          title: "医生社区-内容管理-内容管理列表_医学讲堂",
          hidden: false,
          needLogin: true,
          articleType: "LIVE_MEDICAL_CLASSROOM",
          authCode: authCodeMap.newCom_doctorComty_content_management_list_LIVE_MEDICAL_CLASSROOM,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/list/PPT_CASE_COLLECTION",
        name: authCodeMap.newCom_doctorComty_content_management_list_PPT_CASE_COLLECTION,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/list.vue"),
        meta: {
          title: "医生社区-内容管理-内容管理列表_医学课件",
          hidden: false,
          needLogin: true,
          articleType: "PPT_CASE_COLLECTION",
          authCode: authCodeMap.newCom_doctorComty_content_management_list_PPT_CASE_COLLECTION,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/setting",
        name: authCodeMap.newCom_doctorComty_content_management_setting,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/setting/index.vue"),
        meta: {
          title: "医生社区-内容管理-内容列表设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_content_management_setting,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/labelList",
        name: authCodeMap.newCom_doctorComty_contentManage_labelList,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/labelList.vue"),
        meta: {
          title: "医生社区-内容管理_内容标签",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_contentManage_labelList,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/themeList",
        name: authCodeMap.newCom_doctorComty_content_management_theme_list,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/themeList.vue"),
        meta: {
          title: "医生社区-内容管理_内容专题管理",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_content_management_theme_list,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/edit",
        name: authCodeMap.newCom_doctorComty_content_management_edit,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/edit.vue"),
        meta: {
          title: "内容管理_专题管理_编辑",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_content_management_edit,
          isNew: true,
          // keepAlive: true,
        },
      },
      {
        path: authCodeMap.newCom_doctorComty_content_management_promotionManage,
        name: authCodeMap.newCom_doctorComty_content_management_promotionManage,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/promotionManage/index.vue"),
        meta: {
          title: "健康服务-内容管理-推广管理",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_content_management_promotionManage,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/contentList/MEDICAL_NEWS",
        name: authCodeMap.newCom_doctorComty_contentManage_contentList_MEDICAL_NEWS,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/contentList.vue"),
        meta: {
          title: "医生社区-内容管理_内容创作_医学资讯列表",
          hidden: true,
          needLogin: true,
          articleType: "MEDICAL_NEWS",
          authCode: authCodeMap.newCom_doctorComty_contentManage_contentList_MEDICAL_NEWS,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/contentList/LEARNING",
        name: authCodeMap.newCom_doctorComty_contentManage_contentList_LEARNING,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/contentList.vue"),
        meta: {
          title: "医生社区-内容管理_内容创作_医学文章列表",
          hidden: true,
          needLogin: true,
          articleType: "LEARNING",
          authCode: authCodeMap.newCom_doctorComty_contentManage_contentList_LEARNING,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/contentList/MEDICAL_VIDEO",
        name: authCodeMap.newCom_doctorComty_contentManage_contentList_MEDICAL_VIDEO,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/contentList.vue"),
        meta: {
          title: "医生社区-内容管理_内容创作_医学视频列表",
          hidden: true,
          needLogin: true,
          articleType: "MEDICAL_VIDEO",
          authCode: authCodeMap.newCom_doctorComty_contentManage_contentList_MEDICAL_VIDEO,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/contentList",
        name: authCodeMap.newCom_doctorComty_contentManage_contentList,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/contentList.vue"),
        meta: {
          title: "医生社区-内容管理_内容创作_创作列表",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_contentManage_contentList,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/contentEdit",
        name: authCodeMap.newCom_doctorComty_contentManage_contentEdit,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/contentEdit.vue"),
        meta: {
          title: "医生社区-内容管理_内容创作_创作编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_contentManage_contentEdit,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/authorList",
        name: authCodeMap.newCom_doctorComty_contentManage_authorList,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/authorList.vue"),
        meta: {
          title: "医生社区-内容管理_内容创作_内容作者管理",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_contentManage_authorList,
          isNew: true,
        },
      },
      {
        path: "doctorComty/contentManage/authorEdit",
        name: authCodeMap.newCom_doctorComty_contentManage_authorEdit,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/authorEdit.vue"),
        meta: {
          title: "医生社区-内容管理_内容创作_内容作者管理_创建内容作者",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_contentManage_authorEdit,
          isNew: true,
        },
      },
      {
        path: "doctorComty/" + "contentManage/collectContent",
        name: authCodeMap.newCom_doctorComty_contentManage_collectContent,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/contentManage/collectContent.vue"),
        meta: {
          title: "医生社区-内容管理_征集内容",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorComty_contentManage_collectContent,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_doctorCommunity_deco_index,
        name: authCodeMap.newCom_doctorCommunity_deco_index,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/home/settings.vue"),
        meta: {
          title: "品牌社区_医学社区_社区装修",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorCommunity_deco_index,
          isNew: true,
        },
      },
      {
        path: "doctorComty/communitySettings/communicationPromotion",
        name: authCodeMap.newCom_doctorPromotion,
        component: (): any => import("@/modules/newCommunity/pages/doctorComty/communicationPromotion/index.vue"),
        meta: {
          title: "品牌社区_医学社区_社区传播",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_doctorPromotion,
          isNew: true,
        },
      },
      {
        path: "authorityManage/userList",
        name: authCodeMap.newCom_authorityManage_userList,
        component: (): any => import("@/modules/newCommunity/pages/authorityManage/userList.vue"),
        meta: {
          title: "权限管理-成员列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_authorityManage_userList,
          isNew: true,
        },
      },
      {
        path: "authorityManage/roleList",
        name: authCodeMap.newCom_authorityManage_roleList,
        component: (): any => import("@/modules/newCommunity/pages/authorityManage/roleList.vue"),
        meta: {
          title: "权限管理-角色列表",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_authorityManage_roleList,
          isNew: true,
        },
      },
      {
        path: "authorityManage/roleList/addRole",
        name: authCodeMap.newCom_authorityManage_addRole,
        component: (): any => import("@/modules/newCommunity/pages/authorityManage/addRole.vue"),
        meta: {
          title: "权限管理-角色列表_添加用户",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_authorityManage_addRole,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_geneManage_distributionManagement_list,
        name: authCodeMap.newCom_geneManage_distributionManagement_list,
        component: (): any => import("@/modules/newCommunity/pages/geneManage/distributionManagement/list.vue"),
        meta: {
          title: "检测服务_分发管理",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_geneManage_distributionManagement_list,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_geneManage_distributionManagement_operateRecords,
        name: authCodeMap.newCom_geneManage_distributionManagement_operateRecords,
        component: (): any => import("@/modules/newCommunity/pages/geneManage/distributionManagement/operateRecords.vue"),
        meta: {
          title: "检测服务_分发记录",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_geneManage_distributionManagement_operateRecords,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_geneManage_storeManage_list,
        name: authCodeMap.newCom_geneManage_storeManage_list,
        component: (): any => import("@/modules/newCommunity/pages/geneManage/storeManage/list.vue"),
        meta: {
          title: "检测服务_服务管理",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_geneManage_storeManage_list,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_geneManage_saleRecord_list,
        name: authCodeMap.newCom_geneManage_saleRecord_list,
        component: (): any => import("@/modules/newCommunity/pages/geneManage/saleRecord/list.vue"),
        meta: {
          title: "检测服务_销售记录",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_geneManage_saleRecord_list,
          isNew: true,
        },
      },

      {
        path: authCodeMap.newCom_outpatientService_doctor_add,
        name: authCodeMap.newCom_outpatientService_doctor_add,
        component: (): any => import("@/modules/newCommunity/pages/menzhen/doctorAdd.vue"),
        meta: {
          title: "添加医生排班",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_doctor_add,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_outpatientService_doctor_detail,
        name: authCodeMap.newCom_outpatientService_doctor_detail,
        component: (): any => import("@/modules/newCommunity/pages/menzhen/doctorDetail.vue"),
        meta: {
          title: "医生排班详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_doctor_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_outpatientService_location_add,
        name: authCodeMap.newCom_outpatientService_location_add,
        component: (): any => import("@/modules/newCommunity/pages/menzhen/locationAdd.vue"),
        meta: {
          title: "添加出诊地排班",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_location_add,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_outpatientService_location_detail,
        name: authCodeMap.newCom_outpatientService_location_detail,
        component: (): any => import("@/modules/newCommunity/pages/menzhen/locationDetail.vue"),
        meta: {
          title: "出诊地排班详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_location_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_outpatientService_schedule_record_detail,
        name: authCodeMap.newCom_outpatientService_schedule_record_detail,
        component: (): any => import("@/modules/newCommunity/pages/menzhen/scheduleRecord.vue"),
        meta: {
          title: "排班记录详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_schedule_record_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_outpatientService_serviceSetting,
        name: authCodeMap.newCom_outpatientService_serviceSetting,
        component: (): any => import("@/modules/newCommunity/pages/outpatientServiceNew/index.vue"),
        meta: {
          title: "线下面诊_服务设置",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_serviceSetting,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_outpatientService_serviceSetting_addPatientPlace,
        name: authCodeMap.newCom_outpatientService_serviceSetting_addPatientPlace,
        component: (): any => import("@/modules/newCommunity/pages/outpatientServiceNew/addPatientPlace.vue"),
        meta: {
          title: "新建/编辑出诊地",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_serviceSetting_addPatientPlace,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_outpatientService_serviceSetting_setPatientPlacePrice,
        name: authCodeMap.newCom_outpatientService_serviceSetting_setPatientPlacePrice,
        component: (): any => import("@/modules/newCommunity/pages/outpatientServiceNew/setPatientPlacePrice.vue"),
        meta: {
          title: "修改出诊地价格",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_serviceSetting_setPatientPlacePrice,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_outpatientService_serviceRecord,
        name: authCodeMap.newCom_outpatientService_serviceRecord,
        component: (): any => import("@/modules/newCommunity/pages/outpatientServiceNew/serviceRecord.vue"),
        meta: {
          title: "线下面诊_服务记录",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_outpatientService_serviceRecord,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_giveDrugService_serviceRecord,
        name: authCodeMap.newCom_giveDrugService_serviceRecord,
        component: (): any => import("@/modules/newCommunity/pages/giveDrugService/index.vue"),
        meta: {
          title: "赠药服务_服务记录",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_giveDrugService_serviceRecord,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_accountBind,
        name: authCodeMap.newCom_accountBind,
        redirect: authCodeMap.newCom_accountBind_offiaccount,
        meta: {
          title: "社区设置_账号绑定",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_accountBind,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_accountBind_offiaccount,
        name: authCodeMap.newCom_accountBind_offiaccount,
        component: (): any => import("@/modules/newCommunity/pages/accountBind/offiaccount.vue"),
        meta: {
          title: "社区设置_账号绑定_微信公众号",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_accountBind_offiaccount,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_accountBind_workweixin,
        name: authCodeMap.newCom_accountBind_workweixin,
        component: (): any => import("@/modules/newCommunity/pages/accountBind/workweixin.vue"),
        meta: {
          title: "社区设置_账号绑定_企业微信",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_accountBind_workweixin,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_accountBind_weibo,
        name: authCodeMap.newCom_accountBind_weibo,
        component: (): any => import("@/modules/newCommunity/pages/accountBind/weibo.vue"),
        meta: {
          title: "社区设置_账号绑定_微博",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_accountBind_weibo,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_coupon,
        name: authCodeMap.newCom_coupon,
        component: (): any => import("@/modules/newCommunity/pages/coupon/index.vue"),
        meta: {
          title: "优惠券列表",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_coupon,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_coupon_detail,
        name: authCodeMap.newCom_coupon_detail,
        component: (): any => import("@/modules/newCommunity/pages/coupon/detail.vue"),
        meta: {
          title: "优惠券列表_详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_coupon_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_coupon_userCoupon,
        name: authCodeMap.newCom_coupon_userCoupon,
        component: (): any => import("@/modules/newCommunity/pages/coupon/userCoupon.vue"),
        meta: {
          title: "优惠券管理_优惠券领取明细",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_coupon_userCoupon,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_coupon_add,
        name: authCodeMap.newCom_coupon_add,
        component: (): any => import("@/modules/newCommunity/pages/coupon/addCoupon.vue"),
        meta: {
          title: "优惠券列表_新建/编辑优惠券",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_coupon_add,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_coupon_distribute,
        name: authCodeMap.newCom_coupon_distribute,
        component: (): any => import("@/modules/newCommunity/pages/coupon/couponDistribute.vue"),
        meta: {
          title: "优惠券管理_发放优惠券",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_coupon_distribute,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_coupon_increase_distribute,
        name: authCodeMap.newCom_coupon_increase_distribute,
        component: (): any => import("@/modules/newCommunity/pages/coupon/couponIncrDistribute.vue"),
        meta: {
          title: "优惠券管理_增发优惠券",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_coupon_increase_distribute,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_setting,
        name: authCodeMap.newCom_customerService_setting,
        component: (): any => import("@/modules/newCommunity/pages/customerService/setting.vue"),
        meta: {
          title: "客服设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_setting,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_qaSetting,
        name: authCodeMap.newCom_customerService_qaSetting,
        component: (): any => import("@/modules/newCommunity/pages/customerService/qaSetting.vue"),
        meta: {
          title: "常见问答设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_qaSetting,
          isNew: true,
          keepAlive: false,
        },
      },
      {
        path: authCodeMap.newCom_customerService_gptSetting,
        name: authCodeMap.newCom_customerService_gptSetting,
        component: (): any => import("@/modules/newCommunity/pages/customerService/gptSetting.vue"),
        meta: {
          title: "智能医学助手设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_gptSetting,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_toolDistribution,
        name: authCodeMap.newCom_customerService_toolDistribution,
        component: (): any => import("@/modules/newCommunity/pages/customerService/toolDistribution.vue"),
        meta: {
          title: "工具分发",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_toolDistribution,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_humenCustomerSetting,
        name: authCodeMap.newCom_customerService_humenCustomerSetting,
        component: (): any => import("@/modules/newCommunity/pages/customerService/humenCustomerSetting.vue"),
        meta: {
          title: "人工客服设置",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_humenCustomerSetting,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_editLabelList,
        name: authCodeMap.newCom_customerService_editLabelList,
        component: (): any => import("@/modules/newCommunity/pages/customerService/editLabelList.vue"),
        meta: {
          title: "编辑标签分类",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_editLabelList,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_record,
        name: authCodeMap.newCom_customerService_record,
        component: (): any => import("@/modules/newCommunity/pages/customerService/MessageDeal/auto.vue"),
        meta: {
          title: "客服记录",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_record,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_patient_record,
        name: authCodeMap.newCom_customerService_patient_record,
        component: (): any => import("@/modules/newCommunity/pages/customerService/MessageDeal/patient.vue"),
        meta: {
          title: "用户留言",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_patient_record,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_patient_record_detail,
        name: authCodeMap.newCom_customerService_patient_record_detail,
        component: (): any => import("@/modules/newCommunity/pages/customerService/MessageDeal/MessageDetail.vue"),
        meta: {
          title: "用户留言详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_patient_record_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_doctor_record_detail,
        name: authCodeMap.newCom_customerService_doctor_record_detail,
        component: (): any => import("@/modules/newCommunity/pages/customerService/MessageDeal/MessageDetail.vue"),
        meta: {
          title: "医生留言详情",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_doctor_record_detail,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_doctor_record,
        name: authCodeMap.newCom_customerService_doctor_record,
        component: (): any => import("@/modules/newCommunity/pages/customerService/MessageDeal/doctor.vue"),
        meta: {
          title: "医生留言",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_doctor_record,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_auto_record,
        name: authCodeMap.newCom_customerService_auto_record,
        component: (): any => import("@/modules/newCommunity/pages/customerService/MessageDeal/auto.vue"),
        meta: {
          title: "智能医学助手会话",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_auto_record,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_customerService_record_dialogueDetail,
        name: authCodeMap.newCom_customerService_record_dialogueDetail,
        component: (): any => import("@/modules/newCommunity/pages/customerService/MessageDeal/autoDetail.vue"),
        meta: {
          title: "对话详情",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_customerService_record_dialogueDetail,
          isNew: true,
        },
      },
      /* 有奖推荐 start 24/01/18 */
      {
        path: authCodeMap.newCom_matketing_tool_recommend_with_award,
        name: authCodeMap.newCom_matketing_tool_recommend_with_award,
        component: (): any => import("@/modules/newCommunity/pages/recommendWithAward/index.vue"),
        meta: {
          title: "营销工具-有奖推荐",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_matketing_tool_recommend_with_award,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_matketing_tool_recommend_with_award_publish,
        name: authCodeMap.newCom_matketing_tool_recommend_with_award_publish,
        component: (): any => import("@/modules/newCommunity/pages/recommendWithAward/awardDistribute.vue"),
        meta: {
          title: "营销工具-有奖推荐-发布",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_matketing_tool_recommend_with_award_publish,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_matketing_tool_recommend_with_award_setRecommend,
        name: authCodeMap.newCom_matketing_tool_recommend_with_award_setRecommend,
        component: (): any => import("@/modules/newCommunity/pages/recommendWithAward/setRecommend/index.vue"),
        meta: {
          title: "营销工具-有奖推荐-设置推荐",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_matketing_tool_recommend_with_award_setRecommend,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_matketing_tool_recommend_with_award_activityData,
        name: authCodeMap.newCom_matketing_tool_recommend_with_award_activityData,
        component: (): any => import("@/modules/newCommunity/pages/recommendWithAward/activityData.vue"),
        meta: {
          title: "营销工具-有奖推荐-活动数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_matketing_tool_recommend_with_award_activityData,
          isNew: true,
        },
      },
      /* 有奖推荐 end */
      /* 用户运营 start 24/02/23 */
      {
        path: authCodeMap.newCom_userManage_userOperation,
        name: authCodeMap.newCom_userManage_userOperation,
        component: (): any => import("@/modules/newCommunity/pages/userManage/userOperation/index.vue"),
        meta: {
          title: "用户管理_用户运营",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_userOperation,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_userManage_userOperation_addPlan,
        name: authCodeMap.newCom_userManage_userOperation_addPlan,
        component: (): any => import("@/modules/newCommunity/pages/userManage/userOperation/addPlan.vue"),
        meta: {
          title: "用户管理_用户运营_新建计划",
          hidden: false,
          needLogin: true,
          authCode: authCodeMap.newCom_userManage_userOperation_addPlan,
          isNew: true,
        },
      },
      /* 用户运营 end */
      /* 私域运营 start 2024/03/06 */
      {
        path: authCodeMap.newCom_private_operation_wechat_public_account,
        name: authCodeMap.newCom_private_operation_wechat_public_account,
        component: (): any => import("@/modules/newCommunity/pages/privateOperation/index.vue"),
        meta: {
          title: "私域运营-私域运营-微信公众号",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_private_operation_wechat_public_account,
          isNew: true,
          type: "WX_PUBLICACCOUNT",
        },
      },
      {
        path: authCodeMap.newCom_private_operation_enterprise_wechat,
        name: authCodeMap.newCom_private_operation_enterprise_wechat,
        component: (): any => import("@/modules/newCommunity/pages/privateOperation/index.vue"),
        meta: {
          title: "私域运营-私域运营-企业微信",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_private_operation_enterprise_wechat,
          isNew: true,
          type: "ENTERPRISE_WX",
        },
      },
      {
        path: authCodeMap.newCom_private_operation_weibo,
        name: authCodeMap.newCom_private_operation_weibo,
        component: (): any => import("@/modules/newCommunity/pages/privateOperation/index.vue"),
        meta: {
          title: "私域运营-私域运营-微博",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_private_operation_weibo,
          isNew: true,
          type: "WEIBO",
        },
      },
      {
        path: authCodeMap.newCom_private_operation_viewData,
        name: authCodeMap.newCom_private_operation_viewData,
        component: (): any => import("@/modules/newCommunity/pages/privateOperation/data.vue"),
        meta: {
          title: "私域运营-私域运营-查看数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_private_operation_viewData,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_private_operation_addPlan,
        name: authCodeMap.newCom_private_operation_addPlan,
        component: (): any => import("@/modules/newCommunity/pages/privateOperation/addPlanIndex.vue"),
        meta: {
          title: "私域运营-私域运营-创建计划",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_private_operation_addPlan,
          isNew: true,
        },
      },
      // {
      //   path: authCodeMap.newCom_private_operation_assistant,
      //   name: authCodeMap.newCom_private_operation_assistant,
      //   component: (): any => import("@/modules/newCommunity/pages/privateOperation/assistant.vue"),
      //   meta: {
      //     title: "私域运营-私域运营-运营助手",
      //     hidden: true,
      //     needLogin: true,
      //     authCode: authCodeMap.newCom_private_operation_assistant,
      //     isNew: true,
      //   },
      // },
      {
        path: authCodeMap.newCom_private_operation_assistant_set,
        name: authCodeMap.newCom_private_operation_assistant_set,
        component: (): any => import("@/modules/newCommunity/pages/privateOperation/assistant.vue"),
        meta: {
          title: "私域运营-私域运营-运营助手-设置",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_private_operation_assistant_set,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_private_operation_assistant_list,
        name: authCodeMap.newCom_private_operation_assistant_list,
        component: (): any => import("@/modules/newCommunity/pages/privateOperation/assistantList.vue"),
        meta: {
          title: "私域运营-私域运营-运营助手-今日推荐",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_private_operation_assistant_list,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_private_operation_assistant_edit,
        name: authCodeMap.newCom_private_operation_assistant_edit,
        component: (): any => import("@/modules/newCommunity/pages/privateOperation/assistantEdit.vue"),
        meta: {
          title: "私域运营-私域运营-运营助手-编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_private_operation_assistant_edit,
          isNew: true,
        },
      },
      /* 私域运营 end */
      // 数据中心
      {
        path: authCodeMap.newCom_dataCenter_patientServiceIncome,
        name: authCodeMap.newCom_dataCenter_patientServiceIncome,
        component: (): any => import("@/modules/newCommunity/pages/dataCenter/patientServiceIncome.vue"),
        meta: {
          title: "数据中心-收益数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_dataCenter_patientServiceIncome,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_dataCenter_user,
        name: authCodeMap.newCom_dataCenter_user,
        component: (): any => import("@/modules/newCommunity/pages/dataCenter/userData.vue"),
        meta: {
          title: "数据中心-用户数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_dataCenter_user,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_dataCenter_doctor,
        name: authCodeMap.newCom_dataCenter_doctor,
        component: (): any => import("@/modules/newCommunity/pages/dataCenter/doctorData.vue"),
        meta: {
          title: "数据中心-医生数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_dataCenter_doctor,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_dataCenter_serve,
        name: authCodeMap.newCom_dataCenter_serve,
        component: (): any => import("@/modules/newCommunity/pages/dataCenter/serviceData.vue"),
        meta: {
          title: "数据中心-服务数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_dataCenter_serve,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_dataCenter_content,
        name: authCodeMap.newCom_dataCenter_content,
        component: (): any => import("@/modules/newCommunity/pages/dataCenter/contentData.vue"),
        meta: {
          title: "数据中心-内容数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_dataCenter_content,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_dataCenter_supply,
        name: authCodeMap.newCom_dataCenter_supply,
        component: (): any => import("@/modules/newCommunity/pages/dataCenter/supplyData.vue"),
        meta: {
          title: "数据中心-商品数据",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_dataCenter_supply,
          isNew: true,
        },
      },
      {
        path: authCodeMap.newCom_dataCenter_analysis,
        name: authCodeMap.newCom_dataCenter_analysis,
        component: (): any => import("@/modules/newCommunity/pages/dataCenter/dataAnalysis.vue"),
        meta: {
          title: "数据中心-数据分析",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_dataCenter_analysis,
          isNew: true,
        },
      },
      {
        path: "newCom_newActivityGroupUpdate",
        name: authCodeMap.newCom_newActivityGroupUpdate,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/commonSetting/allActivitiesUpdate.vue"),
        meta: {
          title: "活动更新",
          hidden: true,
          needLogin: true,
          keepAlive: false,
          authCode: authCodeMap.newCom_newActivityGroupUpdate,
          isNew: true,
        },
      },
      {
        path: "newCom_newActivityTools",
        name: authCodeMap.newCom_newActivityTools,
        component: (): any => import("@/modules/newCommunity/pages/newActivityTools/index.vue"),
        meta: {
          title: "活动工具",
          hidden: true,
          needLogin: true,
          keepAlive: false,
          authCode: authCodeMap.newCom_newActivityTools,
          isNew: true,
        },
      },
      {
        path: "templateManage",
        name: authCodeMap.newCom_newActivityTools_templateManage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityTools/template.vue"),
        meta: {
          title: "活动工具-模板管理",
          hidden: true,
          needLogin: true,
          keepAlive: false,
          authCode: authCodeMap.newCom_newActivityTools_templateManage,
          isNew: true,
        },
      },
      {
        path: "questionBankManage",
        name: authCodeMap.newCom_newActivityTools_questionBankManage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityTools/questionBank.vue"),
        meta: {
          title: "活动工具-题库管理",
          hidden: true,
          needLogin: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityTools_questionBankManage,
          isNew: true,
        },
      },
      {
        path: "activityCommonRuleSetting",
        name: authCodeMap.newCom_newActivityTools_activity_rule_setting,
        component: (): any => import("@/modules/newCommunity/pages/newActivityTools/commonRuleSetting/index.vue"),
        meta: {
          title: "活动工具-活动通用规则管理",
          hidden: true,
          needLogin: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityTools_activity_rule_setting,
          isNew: true,
        },
      },
      {
        path: "questionBankManage_addQuestion",
        name: authCodeMap.newCom_newActivityTools_questionBankManage_addQuestion,
        component: (): any => import("@/modules/newCommunity/pages/newActivityTools/questionBankManage/addQuestion.vue"),
        meta: {
          title: "活动工具-题库管理-新增题目",
          hidden: true,
          needLogin: true,
          keepAlive: false,
          authCode: authCodeMap.newCom_newActivityTools_questionBankManage_addQuestion,
          isNew: true,
        },
      },
      {
        path: "questionBankManage_classificationManage",
        name: authCodeMap.newCom_newActivityTools_questionBankManage_classificationManage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityTools/questionBankManage/classificationManage.vue"),
        meta: {
          title: "活动工具-题库管理-分类管理",
          hidden: true,
          needLogin: true,
          keepAlive: false,
          authCode: authCodeMap.newCom_newActivityTools_questionBankManage_classificationManage,
          isNew: true,
        },
      },
      // 快问快答 start 2025-03-25
      {
        path: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_activityList,
        name: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_activityList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/activityListPage.vue"),
        meta: {
          title: "快问快答_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          keepAlive: true,
          authCode: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_activityList,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_edit,
        name: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_edit,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/editPage.vue"),
        meta: {
          title: "快问快答_活动编辑",
          hidden: true,
          needLogin: true,
          authCode: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_edit,
          isNew: true,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_detail,
        name: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_detail,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/activityDetailPage.vue"),
        meta: {
          title: "快问快答_活动列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_detail,
          isBudgetSystemWhiteList: true,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_applyManageList,
        name: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_applyManageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/applyManageListPage.vue"),
        meta: {
          title: "快问快答_报名审核列表",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_applyManageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_taskPreparationManage,
        name: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_taskPreparationManage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/taskPreparationManagePage.vue"),
        meta: {
          title: "快问快答_任务准备管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_taskPreparationManage,
        },
      },
      {
        path: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_manageList,
        name: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_manageList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/submissionManagePage.vue"),
        meta: {
          title: "快问快答_任务明细汇总",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_askAndAnswerQuicklyActivity_manageList,
        },
      },
      {
        path: authCodeMap.newCom_newActivityAskAndAnswerQuicklyManage_rewardList,
        name: authCodeMap.newCom_newActivityAskAndAnswerQuicklyManage_rewardList,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/askAndAnswerQuicklyActivityManage/rewardListPage.vue"),
        meta: {
          title: "快问快答-奖励明细",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityAskAndAnswerQuicklyManage_rewardList,
        },
      },
      // 快问快答 end
      {
        path: authCodeMap.newCom_newActivityManage_reviewsActivityManage_contentDistributeManagePage,
        name: authCodeMap.newCom_newActivityManage_reviewsActivityManage_contentDistributeManagePage,
        component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/contentDistributeManagePage.vue"),
        meta: {
          title: "点评活动-内容分发管理",
          hidden: true,
          needLogin: true,
          isNew: true,
          authCode: authCodeMap.newCom_newActivityManage_reviewsActivityManage_contentDistributeManagePage,
        },
      },
    ],
  },
  {
    path: "/newCommunity/communityProductPc",
    name: "communityProductPc",
    component: (): any => import("@/modules/newCommunity/pages/community/com_product_pc.vue"),
    meta: {
      title: "开通社区",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/communityProduct",
    name: "communityProduct",
    component: (): any => import("@/modules/newCommunity/pages/community/com_product_pc.vue"), // com_product
    meta: {
      title: "开通社区",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/communityOrderSuccess",
    name: "communityOrderSuccess",
    component: (): any => import("@/modules/newCommunity/pages/community/com_order_success.vue"),
    meta: {
      title: "开通社区",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/communityActivateSuccess",
    name: "communityActivateSuccess",
    component: (): any => import("@/modules/newCommunity/pages/community/com_activate_success.vue"),
    meta: {
      title: "开通社区",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/communityPosterLanding",
    name: "communityPosterLanding",
    component: (): any => import("@/modules/newCommunity/pages/community/com_poster_landing.vue"),
    meta: {
      title: "开通社区",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/communityCertify",
    name: "communityCertify",
    component: (): any => import("@/modules/newCommunity/pages/community/com_certify.vue"),
    meta: {
      title: "开通社区",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/communityOrderDetail",
    name: "communityOrderDetail",
    component: (): any => import("@/modules/newCommunity/pages/community/com_order_detail.vue"),
    meta: {
      title: "开通社区",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/createCommunityOrder",
    name: "createCommunityOrder",
    component: (): any => import("@/modules/newCommunity/pages/community/create_com_order.vue"),
    meta: {
      title: "确认订单",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/communityPay",
    name: "communityPay",
    component: (): any => import("@/modules/newCommunity/pages/community/com_pay_code.vue"),
    meta: {
      title: "订单支付",
      hidden: false,
      icon: "tree",
      needLogin: true,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/createCommunity",
    name: "createCommunity",
    component: (): any => import("@/modules/newCommunity/pages/community/create_com_list.vue"),
    meta: {
      title: "爱问医生-千帆社区-新建社区",
      hidden: false,
      icon: "tree",
      needLogin: true,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/createSuccess",
    name: "createSuccess",
    component: (): any => import("@/modules/newCommunity/pages/community/createSuccess.vue"),
    meta: {
      title: "开通成功",
      hidden: false,
      icon: "tree",
      needLogin: true,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/community_list_phone",
    name: "communityListPhone",
    component: (): any => import("@/modules/newCommunity/pages/community/community_list_phone.vue"),
    meta: {
      title: "其他社区认证进度",
      hidden: false,
      icon: "tree",
      needLogin: true,
      isNew: true,
    },
  },

  {
    path: "/newCommunity/activityHistoryPreview",
    name: "activityHistoryPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/historyPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-历史记录",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/newCommunity/uniqueAuditPreview",
    name: "uniqueAuditPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManageListComponents/uniqueAuditPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-机审唯一性",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/newCommunity/pptCaseDetailPreview",
    name: "pptCaseDetailPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManageListComponents/pptCaseDetailPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-病例PPT详情页面",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/newCommunity/liveDetailPreview",
    name: "liveDetailPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManageListComponents/liveDetailPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-直播征集详情页面",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/newCommunity/medicalMeetDetailPreview",
    name: "medicalMeetDetailPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManageListComponents/medicalMeetDetailPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-直播征集详情页面",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/newCommunity/questionnaire/answerSheetPage/answerSheetDetail",
    name: authCodeMap.newCom_questionnaire_answerSheetDetail,
    component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/answerSheetDetail.vue"),
    meta: {
      title: "活动工具_问卷_答卷详情",
      hidden: true,
      needLogin: false,
      authCode: authCodeMap.newCom_questionnaire_answerSheetDetail,
      isNew: true,
    },
  },
  {
    path: "/newCommunity/reviewsContentDetail",
    name: "reviewsContentDetail",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/contentDetail.vue"),
    meta: {
      title: "点评活动_内容详情",
      hidden: true,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/newCommunity/interviewActivity/interviewManage/interviewContentDetail",
    name: "interviewContentDetail",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/manageListComponents/interviewContentDetail.vue"),
    meta: {
      title: "科普专访_专访管理_采访内容详情",
      hidden: true,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/newCommunity/interviewDetail",
    name: "interviewDetail",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/manageListComponents/interviewDetail.vue"),
    meta: {
      title: "科普专访_专访管理_采访内容详情",
      hidden: false,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/uniqueAuditPreview",
    name: "uniqueAuditPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManageListComponents/uniqueAuditPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-机审唯一性",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/pptCaseDetailPreview",
    name: "pptCaseDetailPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManageListComponents/pptCaseDetailPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-病例PPT详情页面",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/liveDetailPreview",
    name: "liveDetailPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManageListComponents/liveDetailPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-直播征集详情页面",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/medicalMeetDetailPreview",
    name: "medicalMeetDetailPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/surveyActivityManage/submissionManageListComponents/medicalMeetDetailPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-直播征集详情页面",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/questionnaire/answerSheetPage/answerSheetDetail",
    name: authCodeMap.newCom_questionnaire_answerSheetDetail,
    component: (): any => import("@/modules/newCommunity/pages/operationTools/pages/questionnaire/answerSheetDetail.vue"),
    meta: {
      title: "活动工具_问卷_答卷详情",
      hidden: true,
      needLogin: true,
      authCode: authCodeMap.newCom_questionnaire_answerSheetDetail,
      isNew: true,
    },
  },
  {
    path: "/external/activityHistoryPreview",
    name: "activityHistoryPreview",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/medicalActivityManage/historyPreview.vue"),
    meta: {
      title: "爱问医生-千帆社区-历史记录",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/reviewsContentDetail",
    name: "reviewsContentDetail",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/reviewsActivityManage/contentDetail.vue"),
    meta: {
      title: "点评活动_内容详情",
      hidden: true,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/interviewDetail",
    name: "externalInterviewDetail",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/interviewActivityManage/manageListComponents/interviewDetail.vue"),
    meta: {
      title: "科普专访_专访管理_采访内容详情",
      hidden: false,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/imageClip",
    name: "imageClip",
    component: (): any => import("@/modules/newCommunity/components/imageClip/index.vue"),
    meta: {
      title: "图片裁剪",
      hidden: false,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/imageClip",
    name: "externalImageClip",
    component: (): any => import("@/modules/newCommunity/components/imageClip/index.vue"),
    meta: {
      title: "图片裁剪",
      hidden: false,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/batchImportVideo",
    name: "externalbatchImportVideo",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/streamActivityManage/batchImportVideo.vue"),
    meta: {
      title: "批量导入审订",
      hidden: false,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/goodsDetail",
    name: "externalGoodsDetail",
    component: (): any => import("@/modules/newCommunity/pages/merchantManage/components/goodsInfo.vue"),
    meta: {
      title: "送审快照",
      hidden: false,
      needLogin: true,
      authCode: "",
      isNew: true,
    },
  },
  {
    path: "/external/docmeePPTEdit",
    name: "externalDocmeePPTEdit",
    component: (): any => import("@/modules/newCommunity/pages/newActivityManage/commonComponents/docmeePPTEdit.vue"),
    meta: {
      title: "PPT编辑器",
      hidden: false,
      needLogin: false,
      authCode: "",
      isNew: true,
    },
  },
];
export default routes;
